import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    am: {
      translation: {
        // ========NavMenuItem=======================
        navMenuItems: [
          "Գլխավոր",
          "Թանգարաններ",
          "Միջոցառումներ",
          "Խանութ",
          "Նորություններ",
          "Մեր մասին",
          "Կապ մեզ հետ",
          "Հաճախ տրվող հարցեր",
          "Տոմսերի զեղչային քաղաքականություն",
          "Գաղտնիության քաղաքականություն",
        ],

        // ==============Buttons===================

        buttons: [
          "Գնել հիմա",
          "Տեսնել Բոլորը",
          "Ուղարկել",
          "Զամբյուղ",
          "Դիմել",
          "ՈՒղարկել",
          "Այո",
          "Ոչ",
          "Սկսեք զրուցել",
          "Գնել տոմս",
          "Անդամակցության քարտ",
          "Գրեք մեզ",
          "Զամբյուղ",
          "Նվիրաբերել",
        ],

        footer_title:
          "ՀՀ Կրթության Գիտության Մշակույթի և Սպորտի նախարարություն",

        news_section_title: "ՆՈՐՈՒԹՅՈՒՆՆԵՐ",

        aboute_us_section_title: ["ԿԱՐԴԱՑԵՔ", "ՄԵՐ ՄԱՍԻՆ"],

        abouteUs_section_info:
          "Թանգարան, գիտական, գիտալուսավորական կառույց է, որտեղ հավաքագրվում, պահպանվում, ուսումնասիրվում, մասսայականացվում են բնապատմական, նյութական և հոգևոր մշակութային հուշարձանները՝ բնության և մարդկային հասարակության զարգացման մասին գիտելիքների մասին սկզբնաղբյուրները։ Թանգարանների ֆոնդերում հիմնականում կենտրոնացվում են իրեղեն առարկաներ, գրավոր աղբյուրներ և արվեստի ստեղծագործություններ։ Ժամանակակից գիտական դասակարգմամբ թանգարանները տարբերվում են ըստ տիպերի և ուղղվածության։ Ըստ տիպերի լինում են գիտահետազոտական և ուսումնական, ըստ ուղղվածության՝ պատմության, բնագիտության, արվեստագիտության, գրականության, տեխնիկայի և այլն։ Առանձին խումբ են կազմում հուշային (մեմորիալ), ինչպես նաև կոմպլեքս թանգարանները։ Հայաստանում թանգարանների նախատիպեր կային դեռևս ուրարտական շրջանում (մ.թ.ա. 9-ից 6-րդ դարեր) Ուրարտուի մայրաքաղաք Տուշպայում և այլ քաղաք-ամրոցներում։ Միջնադարյան Հայաստանում երևան եկան իսկական թանգարանները։ Հովհաննես Դրասխանակերտցին 9-ից 10-դ դարերում իր «Հայոց պատմություն» աշխատության մեջ երեք տիպի թանգարան է հիշատակում՝ արքունի, իշխանական տների և եկեղեցական։ Հայկական թանգարանների կազմակերպման գործը զգալի չափով ընդլայնվեց 19-րդ դարում։",

        museum_slide_title: ["Թանգարաններ", "ՄԵՐ ԹԱՆԳԱՐԱՆՆԵՐԸ"],

        contact_us_section: ["ԿԱՊ ՄԵԶ ՀԵՏ", "Անուն", "Հեռախոս", "Էլ. փոստ"],

        souvenirs_title: ["ՄԵՐ ԱՊՐԱՆՔՆԵՐԸ", "ՀՈՒՇԱՆՎԵՐՆԵՐԻ ԱՌՑԱՆՑ ԽԱՆՈՒԹ"],

        login_btn: "Մուտք",

        placeholder: [
          "Էլ. հասցե",
          "Գաղտնաբառ",
          "Հիշիր ինձ",
          "Անուն",
          "Ազգանուն",
          "Էլ. փոստ",
          "Հաստատել գաղտնաբառը",
          "Հեռախոսահամար",
          "Հաղորդագրություն",
          "Գործող գաղտնաբառ",
          "Երկիր",
          "Տարիք",
        ],

        reset_password_btn: ["Մոռացել եմ գաղտնաբառը", "Վերականգնել"],

        redirect_register: ["Դեռ չունեք պրոֆիլ?", "Գրանցվել"],

        register_btn: "Գրանցվել",

        register_text: [
          "Գրանցվեք և դուք առաջինը կիմանաք մեր թանգարանների այցելությունների և նոր միջոցառումների մասին:",
          "Մուտքագրեք ձեր անունը և ազգանունը։",
          "Մուտքագրեք ձեր էլ․ հասցեն և գաղտնաբառը՝ ձեր հաշիվ մուտք գործելու համար։",
          "Ավելացրեք ձեր բջջային հեռախոսահամարը անհրաժեշտության դեպքում ձեր հետ կապ հաստատելու համար։",
          "Լրացրեք այս մանրամասները",
          "Նշեք ձեր Սեռը",
        ],

        gender_type: ["Իգական", "Արական", "Այլ"],

        validation_inp: [
          "Գրեք ճիշտ էլ. հասցե:",
          "Այս դաշտը պարտադիր է",
          "Գաղտնաբառը պետք է պարունակի առնվազն 8 նիշ",
          "Գաղտնաբառը պետք է պարունակի թիվ",
          "Գաղտնաբառը պետք է պարունակի փոքրատառեր",
          "Գաղտնաբառը պետք է պարունակի մեծատառ",
          "Պարտադիր գրել գաղտնաբառը",
          "Գաղտնաբառները չեն համընկնում",
          "Գրել միայն թվանշան",
        ],

        verifyAccount: [
          "Ստուգման Էլ․ հասցե",
          "Ստացեք նոր կոդ",
          "Եթե ​​կոդ չե՞ք ստացել",
          "Կրկին ուղարկել՝",
          "վայրկյան հետո",
        ],

        reset_password: [
          "Վերականգնել Գատնաբառը",
          "Դուք կստանաք նամակ՝ ձեր գաղտնաբառը վերականգնելու համար",
          "Գրել նոր գաղտնաբառ",
        ],

        // ==============Museum Page start===================
        // ==============Regions===================
        aragatsotn: "Արագածոտն",
        ararat: "Արարատ",
        armavir: "Արմավիր",
        gegharkunik: "Գեղարքունիք",
        kotayk: "Կոտայք",
        lori: "Լոռի",
        shirak: "Շիրակ",
        syunik: "Սյունիք",
        tavush: "Տավուշ",
        vayots_dzor: "Վայոց ձոր",
        yerevan: "Երևան",
        description_museum: "Պատմություն",
        ourEvents: "ՄԵՐ ՄԻՋՈՑԱՌՈՒՄՆԵՐԸ",
        our_address: "Մեր հասցեն",
        working_hours: "Աշխատանքային Ժամեր",
        director: "Տնօրեն",
        phone: "Հեռախոսահամարներ",
        educationalPrograms:
          "ՄՇՏԱԿԱՆ ՑՈՒՑԱԴՐՈՒԹՅՈՒՆՆԵՐ ԿԱՄ ՈՒՍՈՒՄՆԱԿԱՆ ԾՐԱԳՐԵՐ",
        haveQuestions: "Հարցեր ունե՞ք",
        NumberOfVisitors: "Այցելուների քանակը",
        minCount: "Նվազագույնը",
        maxCount: "Առավելագույնը",
        typeMessages: "ընտրել հաղորդագրության թեման",
        educational_program: "Կրթական ծրագիր",
        excursion: "էքսկուրսիա",
        other: "Այլ",
        oneTicket: "Մեկ տոմսի արժեքը",
        RegionsMussseum: "Մարզեր",
        allMussseum: "Բոլորը",
        // ==============Museum Page end===================

        abouteUsPage_title: [
          "ՄԵՐ ՄԱՍԻՆ",
          "Հայաստանի մշակույթի նախարարության պատմություն",
        ],

        country: [
          { am: "Հայաստան" },
          { ad: "Անդորրա" },
          { ae: "Արաբական Միացյալ Էմիրություններ" },
          { af: "Աֆղանստան" },
          { ag: "Անտիգուա և Բարբուդա" },
          { al: "Ալբանիա" },
          { ao: "Անգոլա" },
          { ar: "Արգենտինա" },
          { at: "Ավստրիա" },
          { au: "Ավստրալիա" },
          { ba: "Բոսնիա և Հերցեգովինա" },
          { bb: "Բարբադոս" },
          { bd: "Բանգլադեշ" },
          { be: "Բելգիա" },
          { bf: "Բուրկինա Ֆասո" },
          { bg: "Բուլղարիա" },
          { bh: "Բահրեյն" },
          { bi: "Բուրունդի" },
          { bj: "Բենին" },
          { bn: "Բրունեյ" },
          { bo: "Բոլիվիա" },
          { br: "Բրազիլիա" },
          { bs: "Բահամներ" },
          { bt: "Բութան" },
          { bw: "Բոտսվանա" },
          { by: "Բելառուս" },
          { bz: "Բելիզ" },
          { ca: "Կանադա" },
          { cd: "Կոնգոյի Դեմոկրատական Հանրապետություն" },
          { cf: "Կենտրոնաաֆրիկյան Հանրապետություն" },
          { cg: "Կոնգո Հանրապետություն" },
          { ch: "Շվեյցարիա" },
          { ci: "Կոտ դ'Իվուար" },
          { cl: "Չիլի" },
          { cm: "Կամերուն" },
          { cn: "Չինաստան" },
          { co: "Կոլումբիա" },
          { cr: "Կոստա Ռիկա" },
          { cu: "Կուբա" },
          { cv: "Կաբո Վերդե" },
          { cy: "Կիպրոս" },
          { cz: "Չեխիա" },
          { de: "Գերմանիա" },
          { dj: "Ջիբութի" },
          { dk: "Դանիա" },
          { dm: "Դոմինիկա" },
          { do: "Դոմինիկայի Հանրապետություն" },
          { dz: "Ալժիր" },
          { ec: "Էկվադոր" },
          { ee: "Էստոնիա" },
          { eg: "Եգիպտոս" },
          { eh: "Արեվմտյան Սահարա" },
          { er: "Էրիթրեա" },
          { es: "Իսպանիա" },
          { et: "Եթովպիա" },
          { fi: "Ֆինլանդիա" },
          { fj: "Ֆիջի" },
          { fm: "Միկրոնեզիա" },
          { fr: "Ֆրանսիա" },
          { ga: "Գաբոն" },
          { gb: "Մեծ Բրիտանիա" },
          { gd: "Գրենադա" },
          { ge: "Վրաստան" },
          { gh: "Գանա" },
          { gm: "Գամբիա" },
          { gn: "Գվինեա" },
          { gq: "Էվրիտրեական Գվինեա" },
          { gr: "Հունաստան" },
          { gt: "Գվատեմալա" },
          { gw: "Գվինեա-Բիսաու" },
          { gy: "Գայանա" },
          { hn: "Հոնդուրաս" },
          { hr: "Խորվաթիա" },
          { ht: "Հայիթի" },
          { hu: "Հունգարիա" },
          { id: "Ինդոնեզիա" },
          { ie: "Իռլանդիա" },
          { il: "Իսրայել" },
          { in: "Հնդկաստան" },
          { iq: "Իրաք" },
          { ir: "Իրան" },
          { is: "Իսլանդիա" },
          { it: "Իտալիա" },
          { jm: "Ճամայկա" },
          { jo: "Հորդանան" },
          { jp: "Ճապոնիա" },
          { ke: "Քենիա" },
          { kg: "Ղրղզստան" },
          { kh: "Կամբոջա" },
          { ki: "Կիրիբատի" },
          { km: "Կոմորյան կղզիներ" },
          { kn: "Սենտ Քիտս և Նևիս" },
          { kp: "Հյուսիսային Կորեա" },
          { kr: "Հարավային Կորեա" },
          { kw: "Քուվեյթ" },
          { kz: "Ղազախստան" },
          { la: "Լաոս" },
          { lb: "Լիբանան" },
          { lc: "Սենթ Լյուսիա" },
          { li: "Լիխտենշտեյն" },
          { lk: "Շրի Լանկա" },
          { lr: "Լիբերիա" },
          { ls: "Լեսոտո" },
          { lt: "Լիտվա" },
          { lu: "Լյուքսեմբուրգ" },
          { lv: "Լատվիա" },
          { ly: "Լիբիա" },
          { ma: "Մարոկկո" },
          { mc: "Մոնակո" },
          { md: "Մոլդովա" },
          { mg: "Մադագասկար" },
          { mh: "Մարշալյան կղզիներ" },
          { mk: "Մակեդոնիա" },
          { ml: "Մալի" },
          { mm: "Մյանմա (Բիրմա)" },
          { mn: "Մոնղոլիա" },
          { mr: "Մավրիտանիա" },
          { mt: "Մալթա" },
          { mu: "Մավրիտոս" },
          { mv: "Մալդիվներ" },
          { mw: "Մալավի" },
          { mx: "Մեքսիկա" },
          { my: "Մալայզիա" },
          { mz: "Մոզամբիկ" },
          { na: "Նամիբիա" },
          { ne: "Նիգեր" },
          { ng: "Նիգերիա" },
          { ni: "Նիկարագուա" },
          { nl: "Նիդերլանդներ" },
          { no: "Նորվեգիա" },
          { np: "Նեպալ" },
          { nr: "Նաուրու" },
          { nu: "Նիուե" },
          { nz: "Նոր Զելանդիա" },
          { om: "Օման" },
          { pa: "Պանամա" },
          { pe: "Պերու" },
          { pg: "Պապուա-Նոր Գինեա" },
          { ph: "Ֆիլիպիններ" },
          { pk: "Պակիստան" },
          { pl: "Լեհաստան" },
          { pt: "Պորտուգալիա" },
          { pw: "Պալաու" },
          { py: "Պարագվայ" },
          { qa: "Կատար" },
          { ro: "Ռումինիա" },
          { rs: "Սերբիա" },
          { ru: "Ռուսաստան" },
          { rw: "Ռուանդա" },
          { sa: "Սաուդյան Արաբիա" },
          { sb: "Սոլոմոնյան կղզիներ" },
          { sc: "Սեյշելներ" },
          { sd: "Սուդան" },
          { se: "Շվեդիա" },
          { sg: "Սինգապուր" },
          { si: "Սլովենիա" },
          { sk: "Սլովակիա" },
          { sl: "Սիեռա Լեոնե" },
          { sm: "Սան Մարինո" },
          { sn: "Սենեգալ" },
          { so: "Սոմալի" },
          { sr: "Սուրինամ" },
          { ss: "Հարավային Սուդան" },
          { st: "Սան Տոմե և Պրինսիպի" },
          { sv: "Սալվադոր" },
          { sy: "Սիրիա" },
          { sz: "Սվազիլենդ" },
          { td: "Չադ" },
          { tg: "Տոգո" },
          { th: "Թաիլանդ" },
          { tj: "Տաջիկստան" },
          { tl: "Թիմոր-Լեշտի" },
          { tm: "Թուրքմենստան" },
          { tn: "Թունիս" },
          { to: "Տոնգա" },
          { tr: "Թուրքիա" },
          { tt: "Թրինիդադ և Թոբագո" },
          { tv: "Տուվալու" },
          { tw: "Թայվան" },
          { tz: "Տանզանիա" },
          { ua: "Ուկրաինա" },
          { ug: "Ուգանդա" },
          { us: "ԱՄՆ" },
          { uy: "Ուրուգվայ" },
          { uz: "Ուզբեկստան" },
          { va: "Վատիկան" },
          { vc: "Սենթ Վինսենտ և Գրենադիններ" },
          { ve: "Վենեսուելա" },
          { vn: "Վիետնամ" },
          { vu: "Վանուատու" },
          { ws: "Սամոա" },
          { ye: "Եմեն" },
          { za: "Հարավաֆրիկայի հարավ" },
          { zm: "Զամբիա" },
          { zw: "Զիմբաբվե" },
        ],

        sale_ticket_page_Text_part_1: [
          "1) Մինչև 12 տարեկան երեխաներն",
          "2) Հայաստան ժամանած պետական պաշտոնական պատվիրակություն-ների անդամներին,",
          "3) Հայաստանում հավատարմագրված դիվանագիտական ներկայացուցիչ-ներին,",
          "4) Թանգարանների միջազգային խորհրդի անդամներին (ԻԿՕՄ), թանգարանային աշխատողներին,",
          "5) երկկողմանի ծնողազուրկ 12 տարեկանից բարձր տարիքի երեխաներին, հատուկ խնամքի և կենցաղային սպասարկման կարիք ունեցող ծերերին,",
          "6) Հայաստանի Հանրապետության ու Արցախի Հանրապետության տարածքներում մարտական գործողությունների  ժամանակ ծառայողական պարտականությունները կատարելիս զոհված զինծառայողների ընտանիքների անդամներին,",
          "7) Երկրորդ համաշխարհային պատերազմի մասնակիցներին (Հայաստանի Հանրապետության և նախկին  ԽՍՀՄ պետությունների),",
          "8) հաշմանդամություն ունեցող՝ 1-ին  խմբի (ուղեկցողի  հետ),  հաշմանդամություն ունեցող՝ 2-րդ և 3-րդ խմբերի (առանց ուղեկցողի) անձանց, աղքատության (ընտանեկան) նպաստի համակարգում ընդգրկված նպաստառուներին,",
          "9) բազմազավակ ընտանիքների 12 տարեկանից բարձր երեխաներին,",
          "10) ժամկետային զինծառայողներին,",
          "11) Հայաստանի Հանրապետության սահմանամերձ շրջանների 12 տարեկանից բարձր դպրոցական տարիքի երեխաներին (նախօրոք ներկայացված հայտերի հիման վրա),",
          "12) լրագրողներին` աշխատանքային բոլոր օրերին (անձը և կարգավիճակը հաստատող փաստաթղթի առկայության դեպքում),",
          "13) Հայաստանի Հանրապետության քաղաքացիների համար յուրաքանչյուր ամսվա վերջին շաբաթ օրը մուտքն ազատ է:",
        ],

        sale_ticket_page_Text_part_2: [
          "1) Տոմսի գինը 50 տոկոս զեղչով՝ 12 տարեկանից բարձր դպրոցականների, ուսանողների, Հայաստանի Հանրապետության քաղաքացի հանդիսացող կենսաթոշակառուների, փախստականների համար։",
          "2) Թույլատրել զբոսաշրջային և կորպորատիվ նպատակներով մեծաքանակ տոմսերի վաճառքի դեպքում մշտական այցելության տոմսերի գները նվազեցնել մինչև:",
          "3) 10 տոկոսի չափով՝ նախապես զբոսաշրջային օպերատորների կամ գործակալների հետ կնքելով համապատասխան պայմանագրեր:",
        ],

        sale_ticket_page_block_titles: [
          "ԹԱՆԳԱՐԱՆԻ  ՄՇՏԱԿԱՆ  ՑՈՒՑԱԴՐՈՒԹՅԱՆ  ԱՆՎՃԱՐ  ԱՅՑԵԼՈՒԹՅՈՒՆ  ՏՐԱՄԱԴՐՎՈՒՄ Է",
          "Զեղչեր",
        ],

        sale_ticket_page_title: "Տոմսերի զեղչային քաղաքականություն",
        sale_ticket_page_botom_block: {
          title:
            "ԵՐԵՎԱՆ ՀԱՄԱՅՆՔՈՒՄ 2025 ԹՎԱԿԱՆԻ ՏԵՂԱԿԱՆ ՎՃԱՐՆԵՐԻ ԳԾՈՎ ԱՐՏՈՆՈՒԹՅՈՒՆՆԵՐ ՍԱՀՄԱՆԵԼՈՒ ՄԱՍԻՆ",
          part_1: {
            title: "Մանկապարտեզների վճարներ (2025)",
            subTitle: "0 դրամ տեղական վճար են կատարում՝",
            list: [
              {
                title:
                  "Երեխայի ծնողը կամ օրինական ներկայացուցիչը մշտապես/փաստացի հաշվառված է Երևանում։",
              },
              {
                title: "Երեխան՝",
                items: [
                  "զոհված զինծառայողի ընտանիքից է",
                  "ծնողը զինծառայող է կամ մասնակցել է մարտական գործողություններին",
                  "ծնողը զոհվել/անհետ կորել է ծառայողական պարտականությունների ժամանակ",
                  "միակողմանի կամ երկկողմանի ծնողազուրկ է",
                  "ընտանումի մեջ կա 1-ին կամ 2-րդ խմբի հաշմանդամություն ունեցող ծնող",
                  "հաշմանդամություն ունի կամ պահանջում է հատուկ պայմաններ",
                  "տեղահանված անձ է",
                  "պաշտպանություն կամ փախստականի կարգավիճակ ունի",
                  "Արցախից ուժով տեղահանված ընտանիքի երեխան է",
                ],
              },
            ],
            botomText:
              "12,000 դրամ ամսական վճար՝ մնացած բոլոր երեխաների համար։",
          },
          part_2: {
            title:
              "Ցանկապատ ուսումնական հաստատություններ (երաժշտական, գեղարվեստական, նկարիչ արվեստի դպրոցներ)",
            list: [
              {
                title: "0 դրամ՝",
                items: [
                  "Զոհված զինծառայողների երեխաներ",
                  "Երևանի երիտասարդական սիմֆոնիկ նվագախմբի մասնակիցներ",
                ],
              },
              {
                title: "8,000 դրամ ամսական՝",
                items: [
                  "Խորը երգեցողություն",
                  "Ինստրումենտալ բաժիններ (պիանինո, լարային, հնչյունային, ազգային գործիքներ, զուսպ, ակորդեոն, թավիձ, գիթառ, դհոլ)",
                  "Երգեցողություն",
                  "Խորեոգրաֆիա",
                  "Զննիչ արվեստ",
                  "Թատրոն",
                ],
              },
              {
                title: "4,000 դրամ՝",
                items: [
                  "4 և ավելի երեխաներ ունեցող ընտանիքներ",
                  "Հաշմանդամություն ունեցող ծնողի ընտանիքներ",
                  "Եթե աշակերտը հաճախում է երկրորդ ծրագիր (երգեցողություն/ինստրումենտալ բաժին)",
                ],
              },
              {
                title:
                  "Մինչև 100 երեխա, որոնց վճարման խնդիրներ են եղել մինչև 2018 թվական՝",
                items: ["0 դրամ", "4,000 դրամ՝ քաղաքապետի որոշմամբ"],
              },
            ],
          },
        },

        /////////////////////news////////////////
        newses_page_data: ["ԼՈՒՐԵՐ", "Որոնում"],
        ///////////////////shop/////////////////////////
        shop_page_data: [
          "ԽԱՆՈՒԹ",
          "Ըստ կատեգորիաների",
          "Ըստ թանգարանների",
          "Տվյալներ չեն գտնվել",
        ],
        single_shop_page: [
          "դրամ",
          "ԿԱՏԵԳՈՐԻԱ",
          "ՆՄԱՆԱՏԻՊ ԱՊՐԱՆՔՆԵՐ",
          "Տվյալներ չեն գտնվել",
        ],

        abouteUs_page_data: [
          "Հայաստանի մշակույթի նախարարության պատմությունը սկսվում է Հայաստանի առաջին հանրապետության ժամանակներից: Հայաստանի առաջին հանրապետության կառավարության կազմում 1918թ. դեռևս չկար մշակույթի հարցերով զբաղվող ոչ մի կառույց: 1918 - 2019 թթ. գործում էր Հանրային կրթության մինիստրությունը: 1919թ. մայիսի 21-ին հանրային կրթության մինիստր Մելիք Ղարագյոզյանը դիմում է Մինիստրների խորհրդին՝ առաջարկելով այսուհետ Հանրային կրթության մինիստրությունն անվանել Կրթության և գեղարվեստի մինիստրություն: 1919թ. հուլիսի 1-ին կազմավորվում է Հանրային կրթության և արվեստի մինիստրությունը՝ միջնակարգ դպրոցների, տարրական դպրոցների, արվեստի և հնությունների, բժշկական-սանիտարական բաժիններով:1919թ. հուլիսի 17-ի նիստում ՀՀ մինիստրների խորհուրդը հաստատում է օրենք. «Հնության հուշարձանների և արվեստի բաժինը վերակազմակերպելու մասին. ա) հնության հուշարձանների և արվեստի բաժինը վերակազմակերպել երկու բաժինների՝ ա. հնության հուշարձանների պահպանման, բ. արվեստի հովանավորության.",
          "բ) բանալ Հանրային կրթության և արվեստի մինիստրության 1919 թ. հուլիս-դեկտեմբեր ամիսների համար քսաներկու հազար երկու հարյուր ռուբլու լրացուցիչ վարկ: Մինիստրների խորհրդի գործերի կառավարիչ՝ Գ. Խօջամիրյան»: Սույն օրենքով Հանրային կրթության և արվեստի մինիստրության կառուցվածքում ավելանում է հնությունների պահպանության բաժինը: Մինիստրության մշտական ուշադրության կենտրոնում էր հնությունների պահպանությունը, որի մասին են վկայում մի շարք փաստաթղթեր: Հնության պահպանության բաժինը գործում է մինչև 1920 թվականը և լուծարվում գործառույթները հնությունների պահպանության կոմիտեին անցնելու պատճառով: Մինիստրության ուշադրության կենտրոնում էր նաև Ապագա ազգային թանգարանի հարցը, ինչպես նաև թատերական գործունեությունը:  1920 թ. հունվարի 1-ից մինչև հունիսի 1-ը Կրթության և արվեստի մինիստրության հատուկ հանձնարարությունների կոմիսարի պաշտոնը վարել է Եղիշե Սողոմոնյանը (Չարենց): ",
          " Հայաստանի պատմության թանգարանը մշակութային կազմակերպություն է ազգ կարևորությունը, որն ավելի քան մեկ դար ձեռք է բերել, հավաքել, հայտնաբերել, հաշվառել, պահպանել, ուսումնասիրել, մեկնաբանել և ցուցադրել Հայաստանին և հայությանը առնչվող շոշափելի և ոչ նյութական  մշակութային արժեքներ մարդիկ՝ նպաստելով գիտությանը,  կրթությանը, զբոսաշրջությանը։ զարգացում. Հիմնվելով մոտ չորս հարյուր հազար հնագիտական, ազգագրական, դրամագիտական և այլ հավաքածուներ, թանգարանը փորձում է կամրջել անցյալը և ապագան: Թանգարանի հավաքածուն արտացոլում է մշակույթի ամբողջական պատկերը և Հայաստանի պատմությունը նախապատմական ժամանակներից (մեկ միլիոն ութ հարյուր հազար տարի առաջ) մինչև մեր օրերը։ Թանգարանը հիմնադրվել է Հայաստանի Առաջին Հանրապետության խորհրդարանի 439 օրենք (09.09.1919 թ.). Այն կոչվել է Ազգագրական-մարդաբանական թանգարան-գրադարան։ Դա եղել է այցելուների համար բացվել է 1921թ. օգոստոսի 20-ին: Անվանափոխության ենթարկվել: Հայաստանի պետական կենտրոնական (1922), Մշակութային-պատմական (1931), պատմական (1935), Հայաստանի պատմության պետական թանգարան (1962) և Պատմության թանգարան Հայաստանի (2003 թ.):",
        ],

        privacyPolisyTitle: "Գաղտնիության քաղաքականություն",

        privacyPolisy_left_div: [
          "Անձնական տվյալների ապահովություն`",
          "Ներածություն Սույն «Գաղտնիության քաղաքականությունը» կարգավորում է մեր կողմից Ձեր անձնական տեղեկությունների օգտագործումը:",
          "Տեղեկությունների գաղտնիություն`",
          "Մեզ տրամադրած Ձեր տեղեկությունները համարվում են միանգամայն գաղտնի և չեն կարող տրամադրվել որևէ երրորդ կողմի",
          "Տեղեկությունների հավաքագրում`",
          "Մենք կարող ենք հավաքագրել և պահել ստորև ներկայացված անձնական տեղեկությունները։",
          "Էլ.փոստի հասցե, անուն-ազգանուն, հեռախոսահամար։",
          "Մենք ՉՈՒՆԵՆՔ Ձեր վճարային (կրեդիտային կամ դեբետային) քարտի որևէ տվյալ, քանի որ առցանց գնումները / նվիրաբերությունները / և այլ գործարքները մեր կայքում իրականացվում են բացառապես միջազգային Visa և MasterCard քարտերով և անցնում Verified by Visa և MasterCard Secure Code կանխագրերով:",
          "Կայքում Ձեր կատարած գնումների / նվիրաբերությունների/ և այլ գործարքների պատմությունը և նախընտրած ապրանքների / ծրագրերի ցանկը:",
          "Մեզ հետ կատարված նամակագրությունը (էլեկտրոնային նամակները), եթե այդպիսիք լինեն:",
        ],

        privacyPolisy_right_div: [
          "Տեղեկությունների օգտագործում`",
          "Մեզ համար անձնական տեղեկությունների հավաքագրման առաջնային նպատակը Ձեզ ապահով, հարմարավետ, արդյունավետ և անհատական ծառայություններ մատուցելն է: Սրանով Դուք տալիս եք Ձեր համաձայնությունը, որ մենք կարող ենք օգտագործել Ձեր անձնական տեղեկությունները բացառապես հետևյալի համար",
          "Ձեր հայցած ծառայության և օգնության ապահովում.",
          "Մեր ծառայությունների, բովանդակության և որակի գնահատում և բարելավում.",
          "Ոչ սովորական իրավիճակներում հեռախոսազանգի կամ էլ. փոստի միջոցով հավելյալ տեղեկությունների ճշտում կամ հաղորդում.",
          "Գնումը/ պատվերը / նվիրաբերությունը / գործարքը հաստատող, սխալ լրացված դաշտերի մասին տեղեկացնող և այլ տիպի էլեկտրոնային նամակների ուղարկում (օրինակ` նորություններ, եթե բաժանորդագրված եք մեր փոստառաքման ծառայությանը)",
        ],

        faqTitle: "Հաճախ տրվող հարցեր",

        faqUserRequestsData: [
          "Ո՞ր թանգարանի տոմսերը կարող եմ գնել:",
          "Մեր կայքի այցելուները կարող են գնել կայքում ընգրկված բոլոր թանգարանների տոմսերը:",
          " Գնված տոմսը վավերականության ի՞նչ ժամկետ ունի:",
          "Համակարգից գնված տոմսը ուժի մեջ է 365 օր:",
          "Ի՞նչ է նշանակում Միասնական տոմս:",
          "Միասնական տոմսը դա մի քանի թանգարանների տոմսերի փաթեթն է, որը գնելիս կստանաք զեղչ:",
          "Տոմս գնելիս, ինչպե՞ս կարող եմ ստանալ իմ տոմսը:",
          "Կայքից տոմս գնելու դեպքում, դուք ձեր էլեկտրոնային հասցեին կստանաք տոմսը և QR կոդը, որով և կարող եք այցելել թանգարան:",
          " Ի՞նչ է նշանակում Անդամակցության քարտ:",
          "Անդամակցության քարտը դա մեկ թանգարանի անսահմա-նափակ քանակությամբ մուտքի տոմսն է, որը գործում է 365 օր:",
        ],

        faq_free_tickets_title: "Անվճար տոմսեր",

        faq_sale_tickets_title: "Զեղչված տոմսեր",

        faq_free_tickets: [
          " Մինչև 12 տարեկան երեխաներն,",
          "Հայաստան ժամանած պետական պաշտոնական պատվիրա-կությունների անդամներին,",
          "Հայաստանում հավատարմագրված դիվանագիտական ներկայացուցիչներին,",
          "Թանգարանների միջազգային խորհրդի անդամներին (ԻԿՕՄ), թանգարանային աշխատողներին,",
          "երկկողմանի ծնողազուրկ 12 տարեկանից բարձր տարիքի երեխաներին, հատուկ խնամքի և կենցաղային սպասարկման կարիք ունեցող ծերերին,",
          "Հայաստանի Հանրապետության ու Արցախի Հանրապետության տարածքներում մարտական գործողությունների  ժամանակ ծառայողական պարտականությունները կատարելիս զոհված զինծառայողների ընտանիքների անդամներին,",
          "Երկրորդ համաշխարհային պատերազմի մասնակիցներին (Հայաստանի Հանրապետության և նախկին  ԽՍՀՄ պետությունների),",
          "հաշմանդամություն ունեցող՝ 1-ին  խմբի (ուղեկցողի  հետ),  հաշմանդամություն ունեցող՝ 2-րդ և 3-րդ խմբերի (առանց ուղեկցողի) անձանց, աղքատության (ընտանեկան) նպաստի համակարգում ընդգրկված նպաստառուներին",
          "բազմազավակ ընտանիքների 12 տարեկանից բարձր երեխաներին,",
          "ժամկետային զինծառայողներին",
          "Հայաստանի Հանրապետության սահմանամերձ շրջանների 12 տարեկանից բարձր դպրոցական տարիքի երեխաներին (նախօրոք ներկայացված հայտերի հիման վրա),",
          "լրագրողներին` աշխատանքային բոլոր օրերին (անձը և կարգավիճակը հաստատող փաստաթղթի առկայության դեպքում),",
          "Հայաստանի Հանրապետության քաղաքացիների համար յուրաքանչյուր ամսվա վերջին շաբաթ օրը մուտքն ազատ է:",
        ],

        faq_sale_tickets: [
          "Համայն ՀՀ նորմատիվ ակտերի թանգարանի տոմսի արժեքը 50 տոկոսով զեղչվում է հետևյալ դեպքերում՝",
          "12 տարեկանից բարձր դպրոցականներ",
          "ուսանողներ,",
          "Հայաստանի Հանրապետության քաղաքացի հանդիսացող կենսաթոշակառուներ,",
          "փախստականներ։",
        ],

        privateTicketRegions: [
          { bolor: "Բոլորը" },
          { yerevan: "Երևան" },
          { aragatsotn: "Արագածոտն" },
          { ararat: "Արարատ" },
          { armavir: "Արմավիր" },
          { gegharkunik: "Գեղարքունիք" },
          { kotayk: "Կոտայք" },
          { lori: "Լոռի" },
          { shirak: "Շիրակ" },
          { syunik: "Սյունիք" },
          { tavush: "Տավուշ" },
          { vayots_dzor: "Վայոց Ձոր" },
        ],

        chatBotHint: [
          "Խնդրում ենք նշել ձեր հաղորդագրության մեջ",
          "Նախընտրելի օր",
          "Մասնակիցների քանակը",
          "Ո՞ր տարիքային խմբի մասին է խոսքը",
          "Կազմակերպության կամ անհատի անվանումը",
          "Հեռախոսահամար",
          "Նշեք գիդի լեզուն",
        ],
        otherMessagesBot: "Գրեք ձեր հաղորդագրությունը",
        warningMessages: "Ցանկանու՞մ եք շարունակել",
        startMessages: [
          "Եթե գրանցված չեք, գրեք մեզ ձեր էլ. նամակը թանգարանից պատասխան նամակ ստանալու համար",
          "Բարև Ուրախ եմ տեսնել ձեզ այստեղ: Սեղմելով «Սկսել զրույց» կոճակը, դուք համաձայնում եք, որ ձեր անձնական տվյալները մշակվեն, ինչպես նկարագրված է մեր Գաղտնիության քաղաքականության մեջ:",
        ],

        ticketsType: [
          "Մշտական ցուցադրություն",
          "Անդամակցության քարտ",
          "Միասնական Տոմս",
          " Ժամանակավոր ցուցադրություններ",
        ],

        ticketsType_for_private: [
          { standart: "Ստանդարտ Տոմս" },
          { discount: "Զեղչված տոմս" },
          { free: "Անվճար տոմս" },
          { subscription: "Անդամակցության քարտ" },
          { united: "Միասնական տոմս" },
          { event: "Ցուցադրություն" },
          { product: "Ապրանք" },
          { event_config: "Միջոցառում" },
          { special: "Հատուկ տոմս" },
        ],

        specialTicketLabel: "Հատուկ Տոմս",
        specialTicketDiscountLabel: "Զեղչ",
        specialTicketScheduleLabel: "Հատուկ Տոմսի օր/ժամ",

        weekDaysList: [
          "Կիրակի",
          "Երկուշաբթի",
          "Երեքշաբթի",
          "Չորեքշաբթի",
          "Հինգշաբթի",
          "Ուրբաթ",
          "Շաբաթ",
        ],

        Ticket_type_placeholder: [
          "Մարզ",
          "Ընտրել մարզ",
          "Թանգարան",
          "Ընտրել թանգարան",
          "Միջոցառում",
          "Ընտրել միջոցառում",
          "Գնել տոմս",
          "Ընդամենը - ",
          "Մուտք գործել՝ զամբյուղին տոմս կամ ապրանք ավելացնելու համար:",
        ],

        musseumPage_title: ["ՀԱՅԱՍՏԱՆԻ ԹԱՆԳԱՐԱՆՆԵՐ", "Զտել", "Կարդալ ավելին"],
        webSideMusum: [
          "ՎԵԲ ԿԱՅՔ",
          "հրավիրել",
          "Թանգարանի Անդամակցության քարտ",
          "Պատճենված է",
        ],
        ButtonBlock: [
          "Գնելով Անդամակցության քարտ կարող եք 365 օրվա ընթացքում անսահմանափակ անգամ այցելել թանգարան:",
          "Զբոսավարի, կրթական ծրագրերի և այլ հարցերի համար գրեք",
        ],

        standart: "Ստանդարտ Տոմս",
        discount: "Զեղչ",
        free: "Անվճար",

        infoBuyTicket: [
          "Անվճար տոմսի համար մոտեցեք թանգարան",
          "Էքսկուրսավար հայերեն լեզվով",
          "Էքսկուրսավար օտար լեզվով",
          "Էքսկուրսավարի ծառայությունից օգտվելու համար անհրաժեշտ է նախապես ամրագրել։",
          "Ընդամենը",
          "Գնել տոմս",
          "Աբոնիմենտ տոմս",
          "Աբոնիմենտ տոմսը անսահմանափակ մուտք է 365 օր:",
          "Զեղչված տոմսի համար մոտեցեք թանգարան",
          "Զեղչված և անվճար տոմսի համար մոտեցեք թանգարան",
        ],
        selectCategory: "Ընտրեք կատեգորիա",
        book: "Գիրք",
        souvenir: "Հուշանվեր",
        clothes: "Հագուստ",
        ticket_error_message: "Տոմսն Ընտրված չէ",

        eventPageTitle: "Հայաստանի թանգարանների միջոցառումները",

        location_name: "ՀՀ, Երևան 0010, Վազգեն Սարգսյան 3 Կառավարական տուն 2",

        app_stor_and_google_play: "Ներբեռնեք մեր Հավելվածը",

        footer_botom:
          "  Հայաստանի  Թանգարաններ: Հեղինակային իրավունքները պաշտպանված են: Կայքը ստեղծել է",

        event_single_page: [
          "Տեսնել ավելին",
          "Գնել տոմս",
          "Նկարագրություն",
          "Հրավիրել",
        ],

        event_single_page_modal: [
          "Ամսաթիվ",
          "Ժամանակ",
          "Գին",
          "Հասանելի տոմսերի քանակը",
          "Զեղչված գին",
        ],
        more_events: "Նմանատիպ միջոցառումներ",

        mintitle: "Հայաստանի թանգարանները մեկ հարթակում",
        educationTitle: [
          "Կապվեք թանգարանի հետ ՝ կրթական ծրագրերի տոմսեր պատվիրելու համար ՝ ",
          "հաղորդագրություն ուղարկելով",
          "կամ զանգահարելով:",
        ],
        thisMuseum: "Այս թանգարանի խանութը",
        buy: "Գնել",
        productsErrorMessages: "Ապրանքներ չեն գտնվել",
        Showing: ["Ցուցադրվում են", "արդյունքները", "ից"],
        virtualExcursion: "Վիրտուալ էքսկուրսիա",
        museumBranch: "Թանգարանի մասնաճյուղերը",

        isWrong: [
          "Ինչ - որ բան սխալ է !",
          "Այս պահին տոմսեր չկան",
          "Ապրանքներ ավելացված են զամբյուղում",
          "Տոմս գնելու համար լրացրեք դաշտերը",
          "Գնված էլեկտրոնային տոմսերը կուղարկվեն Ձեր նշած էլեկտրոնային փոստին",
        ],

        profil_side_bar: [
          "Իմ հաշիվը",
          "Հաղորդագրություններ",
          "Պատվերներ",
          "QR Code",
          "Ծանուցումներ",
          "Նվիրատվություններ",
        ],

        section_united_ticket: [
          "Գնեք",
          "և ավելի թանգարանների միասնական տոմս և ստացեք",
          "տոկոս զեղչ:",
        ],

        my_account_page: [
          "Իմ հաշիվը",
          "Սեռ",
          "Արական",
          "Իգական",
          "Այլ",
          "Պահպանել",
          "Դուրս գալ",
        ],

        order_history: [
          "Պատվերի ID",
          "Թանգարանի անվանումը",
          "Ապրանք / Տոմս",
          "Քանակ",
          "Գնման ամսաթիվը",
          "Գին",
          "Կարգավիճակ",
          "Ձախողվել է",
          "Հաստատված",
          "Պատվերների պատմություն",
        ],

        notificationMessages: [
          "Ձեր վճարումը հաջողությամբ կատարվեց: Ստուգեք Ձեր էլ.փոստը:",
          "Ձեր վճարումը ձախողվել է:Խնդրում եմ փորձեք մի փոքր ուշ.",
          "Այստեղ կարող եք բեռնել ձեր տոմսերը",
          "Ձեր վճարումը հաջողությամբ կատարվեց: Ստուգեք Ձեր էլ.փոստը կամ անձնական էջը։",
        ],

        start_date: "Սկիզբ",
        end_date: "Ավարտ",

        qr_standard_price: "Ստանդարտ գին",
        qr_final_price: "Վերջնական գին",
        qr_valid_days_hours: "Այցելության օրեր և ժամեր",

        qr_modal: ["Ներբեռնել", "Տպել", "Ուղարկել նամակ"],

        shop_page_title: ["ԽԱՆՈՒԹ", "Հայաստանի թանգարանների ապրանքները"],

        shop_search: "Որոնում",

        shop_product_category: [
          { book: "Գիրք" },
          { souvenir: "Հուշանվեր" },
          { clothes: "Հագուստ" },
          { other: "Այլ" },
        ],

        shop_all_category: "Բոլոր կատեգորիաները",
        shop_all_Museums: "Բոլոր Թանգարանները",

        news_titles: [
          "Նորություններ",
          "ԿԳՄՍ նախարարության նորություններ",
          "Որոնում",
        ],

        contactUsPage: [
          "ԿԱՊ ՄԵԶ ՀԵՏ",
          "Կրթության, գիտության, մշակույթի և սպորտի նախարարություն",
          "ՀԱՍՑԵ",
          "ՀՀ, Երևան 0010, Վազգեն Սարգսյան 3 Կառավարական տուն 2",
          "ՀԵՌԱԽՈՍԻ ՀԱՄԱՐ",
          "ԷԼ․ՓՈՍՏ",
        ],

        united_ticketPage_title:
          "Միասնական տոմսը ուժի մեջ է 365 օր և վերադարձման ենթակա չէ",

        united_ticketPage_selectedItems: [
          "Դուք ընտրել եք",
          "Թանգարանի միասնական տոմս",
        ],

        single_shop: ["առկա է - ", "Գին "],

        chat_empty_message: "Դուք դեռ հաղորդագրություններ չունեք։",

        yourCartTitle: "Զամբյուղ",

        yourCartMessage:"Զամբյուղում ներկայացված են տվյալ պահին հասանելի տոմսերը՝ իրենց ճշգրիտ գներով։",

        invalidPage: ["Վերադառնալ Գլխավոր էջ", "Էջը չի գտնվել"],

        storeErrorPage: "Էջը ժամանակավորապես չի գործում",

        eventTypes: ["Միջոցառում", "Ժամանակավոր ցուցադրում"],

        cardCheckout: "Վճարել",

        cardDelte: "Ջնջել Բոլորը",

        otherServices: "Այլ Ծառայություններ",

        otherServicesSubTitle:
          "Այստեղ կարող եք տեսնել թանգարանի այլ ծառայությունները:",

        donationBlock: {
          title: "Աջակցիր Մեր Մշակույթին",
          description:
            "Քո օգնությամբ մենք կարող ենք շարունակել կազմակերպել նոր ցուցահանդեսներ, վերականգնել արժեքավոր ցուցանմուշներ և կրթել նոր սերունդներին։",
          textareaPlaceholder: "Նպատակը․․․",
          selectPrice: "Ընտրեք գումարի քանակը",
          otherBtn: "Այլ",
          sendBtn: "Նվիրաբերել",
          processingBtn: "Իրականացվում է...",
          priceType: "Դ․",
          otherInputPlaceholder: "Գումարը",
          minDonationPrice: 1,

          // ✅ Validation messages
          validations: {
            messageMax: "Մեսիջը չի կարող ավելի երկար լինել քան 500 նիշ",
            choosePrice: "Ընտրեք գումարը",
            invalidChoice: "Անվավեր ընտրություն",
            otherRequired: "Մուտքագրեք ձեր ուզած գումարը",
            otherTypeError: "Մուտքագրեք թվային արժեք",
            otherMin: "Գումարը պետք է լինի առնվազն {{min}} Դ․",
          },
        },

        donationsList: {
          title: "Ձեր Նվիրատվությունները",
          status: {
            pending: "Սպասման մեջ",
            confirmed: "Հաստատված",
            Diny: "Մերժված",
          },
          tableHead: {
            id: "Նվիրատվության ID",
            museum_name: "Թանգարանի անվանումը",
            amount: "Նվիրատվության Չափը",
            status: "Կարգավիճակ",
            date: "Ամսթիվը",
          },
        },

        donationSectionHome: {
          title: "Նվիրաբերիր հիմա",
          description:
            "Քո յուրաքանչյուր դրամը օգնում է պահպանել Հայաստանի մշակութային ժառանգությունը և ստեղծել նոր ցուցադրություններ",
        },
      },
    },

    ru: {
      translation: {
        // ========NavMenuItem=======================
        navMenuItems: [
          "Главный",
          "Музеи",
          "События",
          "Магазин",
          "Новости",
          "О нас",
          "Связаться с нами",
          "FAQ",
          "Политика скидок на билеты",
          "Политика конфиденциальности",
        ],

        // ==============Buttons===================

        buttons: [
          "Купить сейчас",
          "Увидеть все",
          "Отправлять",
          "Корзина",
          "Применять",
          "Отправлять",
          "Да",
          "нет",
          "Начать Чат",
          "Купить билет",
          "Карточка участника",
          "Напишите нам",
          "В корзину",
          "Пожертвовать",
        ],

        footer_title:
          "Министерство образования, науки, культуры и спорта Республики Армения",

        news_section_title: "НОВОСТИ",

        aboute_us_section_title: ["ЧИТАТЬ", "О НАС"],

        abouteUs_section_info:
          "Музей представляет собой научно-просветительскую структуру, в которой собираются, сохраняются, изучаются и распространяются природно-исторические, материальные и духовные памятники культуры - первоисточники знаний о природе и развитии человеческого общества. В музейных коллекциях в основном представлены материальные предметы, письменные источники и произведения искусства. Согласно современной научной классификации музеи различаются по типам и направлениям. По типам бывают научно-исследовательские и учебные, по направлению - исторические, естествознательные, искусствоведческие, литературоведческие, технические и т.д. Мемориальные и комплексные музеи образуют отдельную группу. Прообразы музеев в Армении существовали еще в урартский период (9-6 вв. до н.э.) в Тушпе, столице Урарту, и в других городах-крепостях. В средневековой Армении появились настоящие музеи. Ованес Драсханакерци в своем труде «История армян» IX-X веков упоминает три типа музеев: царские, княжеские и церковные. В XIX веке работа по организации армянских музеев значительно расширилась.",

        museum_slide_title: ["МУЗЕИ", "НАШИ МУЗЕИ"],

        contact_us_section: [
          "КОНТАКТЫ С НАМИ",
          "Имя",
          "Телефон",
          "Электронная почта",
        ],

        souvenirs_title: ["НАШИ ПРОДУКТЫ", "ОНЛАЙН МАГАЗИН СУВЕНИРОВ"],

        login_btn: "Вход",

        placeholder: [
          "Эл. адрес",
          "Пароль",
          "Запомнить меня",
          "Имя",
          "Фамилия",
          "Эл. почта",
          "Подтвердите пароль",
          "Номер телефона",
          "Сообщение",
          "Действующий пароль.",
          "Страна",
          "Возраст",
        ],

        reset_password_btn: ["Я забыл пароль", " Восстановить"],

        redirect_register: ["У вас еще нет профиля?", "Регистрация"],

        register_btn: "Регистрация",

        register_text: [
          "Зарегистрируйтесь и вы будете первыми узнавать о наших посещениях музеев и новых мероприятиях.",
          "Введите свое имя и фамилию.",
          "Введите адрес электронной почты адрес и пароль для доступа к вашей учетной записи.",
          "Добавьте номер своего мобильного телефона, чтобы при необходимости связаться с вами.",
          "Заполните эти данные",
          "Введите свой пол",
        ],

        gender_type: ["Женский", "Мужской", "Другой"],

        validation_inp: [
          "Напишите правильный E-mail! адрес:",
          "Это поле обязательно к заполнению",
          "Пароль должен содержать не менее 8 символов",
          "Пароль должен содержать цифру",
          "Пароль должен содержать строчные буквы",
          "Пароль должен содержать заглавную букву",
          "Вы должны написать пароль",
          "Пароли не совпадают",
          "Записать только цифру",
        ],

        verifyAccount: [
          "Проверить электронную почту адрес",
          "Получить новый код",
          "Если вы не получили код",
          "Отправить:",
          "секунду спустя",
        ],

        reset_password: [
          "Сброс пароля",
          "Вы получите электронное письмо для сброса пароля",
          "Напишите новый пароль",
        ],

        // ==============Museum Page start===================
        // ==============Regions===================
        aragatsotn: "Арагацотн",
        ararat: "Арарат",
        armavir: "Армавир",
        gegharkunik: "Гегаркуник",
        kotayk: "Котайк",
        lori: "Лори",
        shirak: "Ширак",
        syunik: "Сюник",
        tavush: "Тавуш",
        vayots_dzor: "Вайоцдзор",
        yerevan: "Ереван",
        description_museum: "История",
        ourEvents: "НАШИ СОБЫТИЯ",
        our_address: "Наш адрес",
        working_hours: "Рабочее время",
        director: "Директор",
        phone: "телефоны",
        educationalPrograms:
          "ПОСТОЯННЫЕ ВЫСТАВКИ ИЛИ ОБРАЗОВАТЕЛЬНЫЕ ПРОГРАММЫ",
        haveQuestions: "Есть вопросы?",
        NumberOfVisitors: "Количество посетителей",
        minCount: "минимум",
        maxCount: "Максимум",
        typeMessages: "Пожалуйста, выберите тему сообщения",
        educational_program: "Образовательная программа",
        excursion: "Экскурсия",
        other: "Другой",
        oneTicket: "Стоимость одного билета",
        RegionsMussseum: "Регионы",
        allMussseum: "Все",
        // ==============Museum Page end===================

        abouteUsPage_title: ["О НАС", "История Министерства культуры Армении"],

        country: [
          { am: "Армения" },
          { jm: "Ямайка" },
          { jp: "Япония" },
          { ss: "Южный Судан" },
          { af: "Афганистан" },
          { al: "Албания" },
          { dz: "Алжир" },
          { ad: "Андорра" },
          { ao: "Ангола" },
          { ag: "Антигуа и Барбуда" },
          { ar: "Аргентина" },
          { au: "Австралия" },
          { at: "Австрия" },
          { bs: "Багамские Острова" },
          { bh: "Бахрейн" },
          { bd: "Бангладеш" },
          { bb: "Барбадос" },
          { by: "Беларусь" },
          { be: "Бельгия" },
          { bz: "Белиз" },
          { bj: "Бенин" },
          { bt: "Бутан" },
          { bo: "Боливия" },
          { ba: "Босния и Герцеговина" },
          { bw: "Ботсвана" },
          { br: "Бразилия" },
          { bn: "Бруней" },
          { bg: "Болгария" },
          { bf: "Буркина-Фасо" },
          { bi: "Бурунди" },
          { cv: "Кабо-Верде" },
          { kh: "Камбоджа" },
          { cm: "Камерун" },
          { ca: "Канада" },
          { cf: "ЦАР" },
          { td: "Чад" },
          { cl: "Чили" },
          { cn: "Китай (Китайская Народная Республика)" },
          { co: "Колумбия" },
          { km: "Коморы" },
          { cd: "ДР Конго" },
          { cr: "Коста-Рика" },
          { hr: "Хорватия" },
          { cu: "Куба" },
          { cy: "Кипр" },
          { cz: "Чехия" },
          { dk: "Дания" },
          { dj: "Джибути" },
          { dm: "Доминика" },
          { do: "Доминиканская Республика" },
          { tl: "Восточный Тимор" },
          { ec: "Эквадор" },
          { eg: "Египет" },
          { sv: "Сальвадор" },
          { gq: "Экваториальная Гвинея" },
          { er: "Эритрея" },
          { ee: "Эстония" },
          { et: "Эфиопия" },
          { fj: "Фиджи" },
          { fi: "Финляндия" },
          { fr: "Франция" },
          { ga: "Габон" },
          { gm: "Гамбия" },
          { ge: "Грузия" },
          { de: "Германия" },
          { gh: "Гана" },
          { gr: "Греция" },
          { gd: "Гренада" },
          { gt: "Гватемала" },
          { gn: "Гвинея" },
          { gw: "Гвинея-Бисау" },
          { gy: "Гайана" },
          { ht: "Гаити" },
          { hn: "Гондурас" },
          { hu: "Венгрия" },
          { is: "Исландия" },
          { in: "Индия" },
          { id: "Индонезия" },
          { ir: "Иран" },
          { iq: "Ирак" },
          { ie: "Ирландия" },
          { il: "Израиль" },
          { it: "Италия" },
          { ci: "Кот-д’Ивуар" },
          { jm: "Ямайка" },
          { jp: "Япония" },
          { jo: "Иордания" },
          { kz: "Казахстан" },
          { ke: "Кения" },
          { ki: "Кирибати" },
          { xk: "Косово" },
          { kw: "Кувейт" },
          { kg: "Кыргызстан" },
          { la: "Лаос" },
          { lv: "Латвия" },
          { lb: "Ливан" },
          { ls: "Лесото" },
          { lr: "Либерия" },
          { ly: "Ливия" },
          { li: "Лихтенштейн" },
          { lt: "Литва" },
          { lu: "Люксембург" },
          { mk: "Северная Македония" },
          { mg: "Мадагаскар" },
          { mw: "Малави" },
          { my: "Малайзия" },
          { mv: "Мальдивы" },
          { ml: "Мали" },
          { mt: "Мальта" },
          { mh: "Маршалловы Острова" },
          { mr: "Мавритания" },
          { mu: "Маврикий" },
          { mx: "Мексика" },
          { fm: "Микронезия" },
          { md: "Молдавия" },
          { mc: "Монако" },
          { mn: "Монголия" },
          { me: "Черногория" },
          { ma: "Марокко" },
          { mz: "Мозамбик" },
          { mm: "Мьянма" },
          { na: "Намибия" },
          { nr: "Науру" },
          { np: "Непал" },
          { nl: "Нидерланды" },
          { nz: "Новая Зеландия" },
          { ni: "Никарагуа" },
          { ne: "Нигер" },
          { ng: "Нигерия" },
          { nu: "Ниуэ" },
          { kp: "КНДР (Корейская Народно-Демократическая Республика)" },
          { no: "Норвегия" },
          { om: "Оман" },
          { pk: "Пакистан" },
          { pw: "Палау" },
          { ps: "Государство Палестина" },
          { pa: "Панама" },
          { pg: "Папуа — Новая Гвинея" },
          { py: "Парагвай" },
          { pe: "Перу" },
          { ph: "Филиппины" },
          { pl: "Польша" },
          { pt: "Португалия" },
          { pr: "Пуэрто-Рико" },
          { qa: "Катар" },
          { cg: "Республика Конго" },
          { ro: "Румыния" },
          { ru: "Россия" },
          { rw: "Руанда" },
          { kn: "Сент-Китс и Невис" },
          { lc: "Сент-Люсия" },
          { vc: "Сент-Винсент и Гренадины" },
          { ws: "Самоа" },
          { sm: "Сан-Марино" },
          { st: "Сан-Томе и Принсипи" },
          { sa: "Саудовская Аравия" },
          { sn: "Сенегал" },
          { rs: "Сербия" },
          { sc: "Сейшельские Острова" },
          { sl: "Сьерра-Леоне" },
          { sg: "Сингапур" },
          { sk: "Словакия" },
          { si: "Словения" },
          { sb: "Соломоновы Острова" },
          { so: "Сомали" },
          { za: "ЮАР" },
          { kr: "Республика Корея" },
          { ss: "Южный Судан" },
          { es: "Испания" },
          { lk: "Шри-Ланка" },
          { sd: "Судан" },
          { sr: "Суринам" },
          { sz: "Эсватини" },
          { se: "Швеция" },
          { ch: "Швейцария" },
          { sy: "Сирия" },
          { tj: "Таджикистан" },
          { tz: "Танзания" },
          { th: "Таиланд" },
          { tg: "Того" },
          { to: "Тонга" },
          { tt: "Тринидад и Тобаго" },
          { tn: "Тунис" },
          { tr: "Турция" },
          { tm: "Туркменистан" },
          { tv: "Тувалу" },
          { ug: "Уганда" },
          { ua: "Украина" },
          { ae: "ОАЭ" },
          { gb: "Великобритания" },
          { us: "США" },
          { uy: "Уругвай" },
          { uz: "Узбекистан" },
          { vu: "Вануату" },
          { va: "Ватикан" },
          { ve: "Венесуэла" },
          { vn: "Вьетнам" },
          { ye: "Йемен" },
          { zm: "Замбия" },
          { zw: "Зимбабве" },
        ],

        sale_ticket_page_Text_part_1: [
          "1) Дети до 12 лет",
          "2) Членам официальных государственных делегаций, прибывающим в Армению,",
          "3) Дипломатические представители, аккредитованные в Армении,",
          "4) Членам Международного совета музеев (ИКОМ), музейным работникам,",
          "5) двусторонне осиротевшие дети старше 12 лет, пожилые люди, нуждающиеся в особом уходе и бытовом обслуживании,",
          "6) Членам семей военнослужащих, погибших при исполнении служебных обязанностей в ходе боевых действий на территориях Республики Армения и Республики Арцах,",
          "7) Участники Второй мировой войны (Республики Армения и стран бывшего СССР),",
          "8) инвалиды 1-й группы (с сопровождающим), инвалиды 2-й и 3-й групп (без сопровождающего), льготники, включенные в систему пособий по бедности (семейным),",
          "9) дети старше 12 лет из многодетных семей,",
          "10) призывники,",
          "11) Дети школьного возраста старше 12 лет в приграничных районах Республики Армения (на основании заранее поданных заявлений),",
          "12) журналисты - во все рабочие дни (при наличии документа, подтверждающего личность и статус),",
          "13) Вход бесплатный для граждан Республики Армения в последнюю субботу каждого месяца.",
        ],

        sale_ticket_page_Text_part_2: [
          "1) Стоимость билета со скидкой 50% для школьников старше 12 лет, студентов, пенсионеров, являющихся гражданами Республики Армения, беженцев.",
          "2) Разрешить снизить цены на билеты для постоянного посещения в случае продажи большого количества билетов для туристических и корпоративных целей до:",
          "3) В размере 10 процентов, предварительно заключив соответствующие соглашения с туроператорами или агентами:",
        ],

        sale_ticket_page_block_titles: [
          "ПРЕДОСТАВЛЯЕТСЯ БЕСПЛАТНОЕ ПОСЕЩЕНИЕ ПОСТОЯННОЙ ЭКСПОЗИЦИИ МУЗЕЯ",
          "Скидки",
        ],

        sale_ticket_page_title: "Политика скидок на билеты",

        sale_ticket_page_botom_block: {
          title:
            "О УСТАНОВЛЕНИИ ЛЬГОТ ПО МЕСТНЫМ СБОРАМ В ГРАМАДЕ ЕРЕВАН В 2025 ГОДУ",
          part_1: {
            title: "Плата за детские сады (2025)",
            subTitle: "Местный сбор в размере 0 драмов оплачивают:",
            list: [
              {
                title:
                  "Родитель или законный представитель ребёнка постоянно/фактически зарегистрирован в городе Ереван.",
              },
              {
                title: "Ребёнок:",
                items: [
                  "из семьи погибшего военнослужащего",
                  "Родитель является военнослужащим или участвовал в боевых действиях",
                  "Родитель погиб/пропал без вести при исполнении служебных обязанностей",
                  "является круглым или частичным сиротой",
                  "В семье есть родитель с инвалидностью 1-й или 2-й группы",
                  "имеет инвалидность или нуждается в особых условиях",
                  "Внутренне перемещённое лицо",
                  "Имеет статус беженца или просителя убежища",
                  "Из семьи, вынужденно перемещённой из Арцаха",
                ],
              },
            ],
            botomText:
              "12 000 драмов ежемесячная плата — для всех остальных детей.",
          },
          part_2: {
            title:
              "Внешкольные учреждения (музыкальные, художественные, школы изобразительного искусства)",
            list: [
              {
                title: "0 драмов:",
                items: [
                  "Дети погибших военнослужащих",
                  "Участники юношеского симфонического оркестра «Ереван»",
                ],
              },
              {
                title: "8 000 драмов ежемесячно:",
                items: [
                  "Углублённое пение",
                  "Инструментальные отделения (фортепиано, струнные, духовые, национальные, ударные, аккордеон, тавиж, гитара, дхол)",
                  "Пение",
                  "Хореография",
                  "Изобразительное искусство",
                  "Театральное искусство",
                ],
              },
              {
                title: "4 000 драмов:",
                items: [
                  "Семьи с 4 и более детьми",
                  "Семьи с родителем-инвалидом",
                  "Если учащийся посещает вторую программу (пение/инструментальное отделение)",
                ],
              },
              {
                title:
                  "До 100 детей, у которых возникли проблемы с оплатой из-за различий в платежах до 2018 года:",
                items: ["0 драмов", "4 000 драмов по решению мэра"],
              },
            ],
          },
        },

        abouteUs_page_data: [
          "История Министерства культуры Армении начинается со времен первой Республики Армения. В составе правительства первой республики Армения в 1918 г. еще не существовало учреждения, занимающегося культурными вопросами. 1918 - 2019 г. действовало Министерство народного просвещения. 1919 год 21 мая министр народного образования Мелик Карагезян обратился к Совету министров с предложением впредь называть Министерство народного образования Министерством образования и изобразительных искусств. 1919 год 1 июля было создано Министерство народного образования и искусств с отделами средних школ, начальных школ, искусства и древностей, а также медико-санитарным отделами. На заседании 17 июля Совет Министров РА утвердил закон. «О реорганизации отдела памятников старины и искусства. а) реорганизовать отдел памятников старины и искусства на два отдела: а. сохранение древних памятников, б. меценатство.",
          "б) ключ Министерства народного просвещения и искусств 1919 года. дополнительный кредит в размере двадцати двух тысяч двухсот рублей за июль-декабрь. Управляющий делами Совета Министров: Г. Ходжамирян». Этим законом в структуру Министерства народного образования и искусств добавлен Департамент охраны древностей. Постоянное внимание министерства уделялось сохранению древностей, о чем свидетельствует ряд документов. Отдел древностей действовал до 1920 года и был распущен в связи с передачей функций Комитету древностей. Вопрос будущего Национального музея, а также театральная деятельность также находились в центре внимания министерства. В 1920 году С 1 января по 1 июня Егише Согомян (Чаренц) занимал должность уполномоченного по особым поручениям Министерства образования и искусства.",
          "Музей истории Армении – культурная организация национального значения, которая на протяжении более века приобретала, собирала, открывала, записывала, сохраняла, изучала, интерпретировала и экспонировала материальные и нематериальные культурные ценности, связанные с Арменией и армянским народом. , вклад в науку, образование, туризм. разработка. Основываясь на почти четырехстах тысячах археологических, этнографических, нумизматических и других коллекций, музей пытается соединить прошлое и будущее. Коллекция музея отражает полную картину культуры и истории Армении с доисторических времен (миллион восемьсот тысяч лет назад) до наших дней. Музей был основан Законом 439 Парламента Первой Республики Армения (09.09.1919). Он назывался Этнографо-антропологический музей-библиотека. Он был открыт для посетителей в 1921 году. 20 августа. Пройти смену имени. Государственный центр Армении (1922 г.), Культурно-исторический (1931 г.), Исторический (1935 г.), Государственный исторический музей Армении (1962 г.) и Музей истории Армении (2003 г.).",
        ],

        /////////////////////news////////////////
        newses_page_data: ["НОВОСТИ", "Поиск"],
        ///////////////////shop/////////////////////////
        shop_page_data: [
          "МАГАЗИН",
          "По категориям",
          "По музеям",
          "Данные не найдены",
        ],
        single_shop_page: [
          "АМД",
          "КАТЕГОРИЯ",
          "ПОХОЖИЕ ПРОДУКТЫ",
          "Данные не найдены",
        ],
        privacyPolisyTitle: "Политика конфиденциальности",

        privacyPolisy_left_div: [
          "Безопасность персональных данных:",
          "Введение Настоящая Политика конфиденциальности регулирует использование нами вашей личной информации.",
          "Конфиденциальность информации:",
          "Информация, которую вы нам предоставляете, считается строго конфиденциальной и не может быть передана третьим лицам.",
          "Сбор информации:",
          "Мы можем собирать и хранить персональную информацию, описанную ниже.",
          "Адрес электронной почты, ФИО, номер телефона.",
          "У нас НЕТ данных вашей платежной (кредитной или дебетовой) карты, так как онлайн-покупки/пожертвования/и другие транзакции на нашем сайте осуществляются исключительно с международными картами Visa и MasterCard и проходят через префиксы Verified by Visa и MasterCard Secure Code.",
          "История ваших покупок/пожертвований/и других транзакций на сайте и список предпочитаемых продуктов/программ.",
          "Переписка (электронные письма), если таковая имеется, с нами.",
        ],

        privacyPolisy_right_div: [
          "Использование информации:",
          "Основная цель сбора личной информации для нас — предоставить вам безопасные, удобные, эффективные и персонализированные услуги. Настоящим вы соглашаетесь, что мы можем использовать вашу личную информацию исключительно для следующих целей:",
          "Предоставление запрошенных вами услуг и помощи;",
          "Оценка и улучшение наших услуг, контента и качества;",
          "В нестандартных ситуациях позвоните по телефону или напишите электронное письмо. проверка или сообщение дополнительной информации по почте;",
          "Отправка электронных писем с подтверждением покупки/заказа/пожертвования/транзакции, информированием о неправильно заполненных полях и других типов электронных писем (например, новостей, если вы подписаны на нашу рассылку)",
        ],

        faqTitle: "Часто задаваемые вопросы",

        faqUserRequestsData: [
          "В какой музей можно купить билеты?",
          "Посетители нашего сайта могут приобрести билеты во все музеи, представленные на сайте.",
          "Какой срок действия купленного билета?",
          "Билет, приобретенный в системе, действителен в течение 365 дней.",
          "Что такое единый билет?",
          "Единый билет — это пакет билетов в несколько музеев, на который вы получите скидку.",
          "При покупке билета, как мне его получить?",
          "Если вы купите билет на сайте, вы получите билет и QR-код на свой адрес электронной почты, с помощью которого вы сможете посетить музей.",
          "Что означает карточка участника?",
          "Карточка участника — это безлимитный входной билет в один музей, действительный в течение 365 дней.",
        ],

        faq_free_tickets_title: "Бесплатные билеты",

        faq_sale_tickets_title: "Билеты со скидкой",

        faq_free_tickets: [
          "Дети до 12 лет",
          "Членам официальных государственных делегаций, прибывших в Армению,",
          "дипломатические представители, аккредитованные в Армении,",
          "Членам Международного совета музеев (ИКОМ), музейным работникам,",
          "двусторонне осиротевшие дети старше 12 лет, пожилые люди, нуждающиеся в особом уходе и бытовом обслуживании,",
          "Членам семей военнослужащих, погибших при исполнении служебных обязанностей в ходе боевых действий на территориях Республики Армения и Республики Арцах,",
          "Участники Второй мировой войны (Республики Армения и стран бывшего СССР),",
          "инвалиды 1-й группы (с сопровождающим), инвалиды 2-й и 3-й групп (без сопровождающего), льготники, включенные в систему пособий по бедности (семейным)",
          "дети старше 12 лет из многодетных семей,",
          "солдат-срочник",
          "Дети школьного возраста старше 12 лет в приграничных районах Республики Армения (на основании заранее поданных заявлений),",
          "журналисты - во все рабочие дни (при наличии документа, подтверждающего личность и статус),",
          "Вход бесплатный для граждан Республики Армения в последнюю субботу каждого месяца.",
        ],

        faq_sale_tickets: [
          "Стоимость билета в Музей всех нормативных актов РА снижается на 50% в следующих случаях:",
          "Школьники старше 12 лет,",
          "студенты,",
          "Пенсионеры, являющиеся гражданами Республики Армения,",
          "беженцы.",
        ],

        privateTicketRegions: [
          { bolor: "Все" },
          { yerevan: "Ереван" },
          { aragatsotn: "Арагацотн" },
          { ararat: "Арарат" },
          { armavir: "Армавир" },
          { gegharkunik: "Гегаркуник" },
          { kotayk: "Котайк" },
          { lori: "Лори" },
          { shirak: "Ширак" },
          { syunik: "Сюник" },
          { tavush: "Тавуш" },
          { vayots_dzor: "Вайоцдзор" },
        ],
        chatBotHint: [
          "Пожалуйста, укажите в сообщении",
          "Желаемый день",
          "Число участников",
          "О какой возрастной группе мы говорим?",
          "Название организации или физического лица",
          "Номер телефона",
          "Укажите язык руководства",
        ],
        otherMessagesBot: "Напишите свое сообщение",
        warningMessages: "Вы хотите продолжать?",
        startMessages: [
          "Если вы не зарегистрированы, напишите нам свой адрес электронной почты. письмо для получения ответного письма от музея",
          "Привет. Приятно видеть тебя здесь. Нажимая кнопку «Начать чат», вы соглашаетесь на обработку ваших персональных данных, как описано в нашей Политике конфиденциальности.",
        ],
        musseumPage_title: ["МУЗЕИ АРМЕНИИ", "Фильтр", "Читать далее"],
        webSideMusum: [
          "ВЕБ-САЙТ",
          "приглашать",
          "Карточка участника",
          "Сылка скопирована",
        ],
        ButtonBlock: [
          "Купив карточка участника, вы можете посещать музей неограниченное количество раз в течение 365 дней:",
          "Напишите нам для бронирования гида, образовательных программ и по другим вопросам.",
        ],

        ticketsType: [
          "Постоянный показ",
          "Карточка участника",
          "Единый билет",
          "Временные выставки",
        ],

        ticketsType_for_private: [
          { standart: "Стандартный билет" },
          { discount: "Билет со скидкой" },
          { free: "Бесплатный билет" },
          { subscription: "Карточка участника" },
          { united: "Единый билет" },
          { event: "Событие" },
          { product: "Продукт" },
          { special: "Специальный билет" },
        ],
        specialTicketLabel: "Специальный билет",
        specialTicketDiscountLabel: "Скидка",
        specialTicketScheduleLabel: "Дни/часы специального билета",

        weekDaysList: [
          "Воскресенье",
          "Понедельник",
          "Вторник",
          "Среда",
          "Четверг",
          "Пятница",
          "Суббота",
        ],
        Ticket_type_placeholder: [
          "Регион",
          "Выбрать регион",
          "Музей",
          "Выбрать музей",
          "Событие",
          "Выбрать событие",
          "Купить билет",
          "Итого - ",
          "Войдите, чтобы добавить билет или товар в корзину.",
        ],
        standart: "Стандарт",
        discount: "Скидка",
        free: "Бесплатно",

        infoBuyTicket: [
          "Приходите в музей за бесплатным билетом",
          "Гид на армянском языке",
          "Гид на иностранном языке",
          "Чтобы воспользоваться услугой экскурсовода, необходимо заранее забронировать место.",
          "Общий",
          "Купить билет",
          "Карточка участника",
          "Карточка участника — это безлимитный доступ на 365 дней.",
          "Зайдите в музей и купите билет со скидкой.",
          "Зайдите в музей, чтобы получить бесплатный и льготный билет.",
        ],
        selectCategory: "Выберите категорию",
        book: "Книга",
        souvenir: "Сувенир",
        clothes: "Одежда",

        ticket_error_message: "Билет не выбран",

        eventPageTitle: "Мероприятия музеев Армении",

        location_name:
          "Дом Правительства 2, Вазген Саргсян 3, Ереван 0010, Армения",

        app_stor_and_google_play: "Загрузите наше приложение",

        footer_botom: "  Музеи Армении. Авторские права защищены. Сайт создан",

        event_single_page: [
          "Узнать больше",
          "Купить билет",
          "Описание",
          "Приглашать",
        ],

        event_single_page_modal: [
          "Дата",
          "Время",
          "Цена",
          "Количество доступных билетов",
          "Цена со скидкой",
        ],

        more_events: "Подобные события",

        mintitle: "Музеи Армении на одной платформе",
        educationTitle: [
          "Свяжитесь с музеем, чтобы заказать билеты на образовательные программы, ",
          "отправив сообщение",
          "или позвонив по телефону.",
        ],
        thisMuseum: "Магазин этого музея",
        buy: "Купить",
        productsErrorMessages: "Продукты не найдены",
        Showing: ["Показаны", "из", "результатов"],
        virtualExcursion: "Виртуальная экскурсия",
        museumBranch: "Филиалы музея",

        isWrong: [
          "Что-то не так!",
          "На данный момент билетов нет в наличии",
          "Товары добавлены в корзину",
          "Заполните поля, чтобы купить билет",
          "Купленные электронные билеты будут отправлены на указанную вами электронную почту.",
        ],

        profil_side_bar: [
          "Мой аккаунт",
          "Сообщения",
          "Заказы",
          "QR код",
          "Уведомления",
          "Пожертвования",
        ],

        section_united_ticket: [
          "Купить ЕДИНЫЙ БИЛЕТ НА",
          "МУЗЕЕВ И ПОЛУЧИТЕ СКИДКУ",
          "ПРОЦЕНТОВ.",
        ],

        my_account_page: [
          "Мой аккаунт",
          "Пол",
          "Мужской",
          "Женский",
          "Другой",
          "Сохранять",
          "Выйти",
        ],

        order_history: [
          "Номер заказа",
          "Название музея",
          "Продукт/Билет",
          "Количество",
          "Дата покупки",
          "Цена",
          "Положение дел",
          "Неуспешный",
          "Подтвержденный",
          "История заказов",
        ],

        notificationMessages: [
          "Ваши изменения успешно сохранены․",
          "В настоящее время ваши изменения не могут быть сохранены.Пожалуйста, повторите попытку позже.",
          "Вы можете скачать билеты здесь",
          "Ваш платеж прошел успешно. Проверьте свою электронную почту или личную страницу.",
        ],

        start_date: "Дата начала",
        end_date: "Дата окончания",

        qr_standard_price: "Стандартная цена",
        qr_final_price: "Итоговая цена",
        qr_valid_days_hours: "Дни и часы посещения",

        qr_modal: ["Скачать", "Печать", "Отправить письмо"],

        event_config: "Мероприятие",

        shop_page_title: ["МАГАЗИН", "Товары  музеев Армении"],

        shop_search: "Поиск",

        shop_product_category: [
          { book: "Книга" },
          { souvenir: "Сувенир" },
          { clothes: "Одежда" },
          { other: "Другое" },
        ],

        shop_all_category: "Все категории",

        shop_all_Museums: "Все музеи",

        news_titles: ["Новости", "Новости МОНКС", "Поиск"],

        contactUsPage: [
          "СВЯЗАТЬСЯ С НАМИ",
          "Министерство образования, науки, культуры и спорта",
          "АДРЕС:",
          "РА, Ереван 0010, Вазгена Саргсяна 3 Дом Правительства 2:",
          "Номер телефона",
          "ЭЛ. АДРЕС:",
        ],

        united_ticketPage_title:
          "Единый билет действителен в течение 365 дней и не подлежит возврату.",

        united_ticketPage_selectedItems: ["Вы выбрали один билет в", "музея"],
        single_shop: ["доступен -", "Цена "],

        chat_empty_message: "У вас пока нет сообщений.",

        yourCartTitle: "Корзина",

        yourCartMessage:"В корзине представлены доступные на данный момент билеты с точными ценами.",


        invalidPage: ["Вернуться на главную страницу", "Страница не найдена"],

        storeErrorPage: "Страница временно недоступна",

        eventTypes: ["Мероприятие", "Временный показ"],

        cardCheckout: "Платить",

        cardDelte: "Удалить все",

        otherServices: "Другие услуги",

        otherServicesSubTitle:
          "Ознакомиться с другими услугами музея можно здесь.",

        donationBlock: {
          title: "Поддержите нашу культуру",
          description:
            "С вашей помощью мы можем продолжать организовывать новые выставки, восстанавливать ценные экспонаты и обучать новые поколения.",
          textareaPlaceholder: "Цель...",
          selectPrice: "Выберите сумму пожертвования",
          otherBtn: "Другое",
          sendBtn: "Пожертвовать",
          processingBtn: "Processing...",
          priceType: "AMD",
          otherInputPlaceholder: "Сумма",
          minDonationPrice: 1,

          // ✅ Validation messages
          validations: {
            messageMax: "Сообщение не может быть длиннее 500 символов",
            choosePrice: "Пожалуйста, выберите сумму",
            invalidChoice: "Неверный выбор",
            otherRequired: "Введите желаемую сумму",
            otherTypeError: "Введите числовое значение",
            otherMin: `Сумма должна быть не менее {{min}} AMD`,
          },
        },

        donationsList: {
          title: "Ваши пожертвования",
          status: {
            pending: "В ожидании",
            confirmed: "Подтверждено",
            deny: "Отклонено",
          },
          tableHead: {
            id: "ID пожертвования",
            museum_name: "Название музея",
            amount: "Сумма пожертвования",
            status: "Статус",
            date: "Дата",
          },
        },

        donationSectionHome: {
          title: "Пожертвуй сейчас",
          description:
            "Каждый твой драм помогает сохранить культурное наследие Армении и создать новые выставки",
        },
      },
    },
    en: {
      translation: {
        // ========NavMenuItem=======================
        navMenuItems: [
          "Home",
          "Museums",
          "Events",
          "Shop",
          "News",
          "About us",
          "Contact Us",
          "FAQ",
          "Ticket Discount Policy",
          "Privacy Policy",
        ],

        // ==============Buttons===================

        buttons: [
          "Buy now",
          "See All",
          "Send",
          "Basket",
          "Apply",
          "Send",
          "Yes",
          "No",
          "Start Chat",
          "Buy Ticket",
          "Membership card",
          "Write to us",
          "Add to cart",
          "Donate",
        ],

        footer_title:
          "Ministry of Education, Science, Culture and Sports of the Republic of Armenia",

        news_section_title: "NEWS",

        aboute_us_section_title: ["READ", "ABOUT US"],

        abouteUs_section_info:
          'The museum is a scientific and educational structure, where natural historical, material and spiritual cultural monuments are collected, preserved, studied, and disseminated - the primary sources of knowledge about nature and the development of human society. Museum collections mainly focus on material objects, written sources and works of art. According to the modern scientific classification, museums differ according to types and direction. According to the types, there are research and educational ones, according to the direction - history, natural science, art science, literature, technology, etc. Memorial and complex museums form a separate group. There were prototypes of museums in Armenia as early as the Urartian period (9th to 6th centuries BC) in Tushpa, the capital of Urartu, and in other city-fortresses. Real museums appeared in medieval Armenia. Hovhannes Draskhanakertsi in his work "History of Armenians" in the 9th to 10th centuries mentions three types of museums: royal, princely, and church. The work of organizing Armenian museums expanded significantly in the 19th century.',

        museum_slide_title: ["MUSEUMS", "OUR MUSEUMS"],

        contact_us_section: ["CONTACT US", "Name", "Phone", "Email"],

        souvenirs_title: ["OUR PRODUCTS", "ONLINE SOUVENIR STORE"],

        login_btn: "Sign in",

        placeholder: [
          "Email address:",
          "Password",
          "Remember me",
          "Name",
          "Surname",
          "E-mail",
          "Confirm password",
          "Phone number",
          "Message",
          "A valid password",
          "Country",
          "Age",
        ],

        reset_password_btn: ["I forgot my password", "Restore"],

        redirect_register: ["Dont have a profile yet?", "Register"],

        register_btn: "Register",

        register_text: [
          "Register and you will be the first to know about our museum visits and new events.",
          "Enter your first and last name.",
          "Enter your email address and password to access your account.",
          "Add your mobile phone number so we can contact you if necessary.",
          "Fill in these details",
          "Enter your gender",
        ],

        gender_type: ["Female", "Male", "Other"],

        validation_inp: [
          "Write the correct E-mail! address.",
          "This field is required",
          "The password must contain at least 8 characters",
          "Password must contain a number",
          "Password must contain lowercase letters",
          "The password must contain a capital letter",
          "You must write a password",
          "Password mismatch",
          "Write only digit",
        ],

        verifyAccount: [
          "Check Email address",
          "Get a new code",
          "If you havent received a code",
          "Resend:",
          "second later",
        ],

        reset_password: [
          "Reset Password",
          "You will receive an email to reset your password",
          "Write a new password",
        ],

        // ==============Museum Page start===================
        // ==============Regions===================
        aragatsotn: "Aragatsotn",
        ararat: "Ararat",
        armavir: "Armavir",
        gegharkunik: "Gegharkunik",
        kotayk: "Kotayk",
        lori: "Lori",
        shirak: "Shirak",
        syunik: "Syunik",
        tavush: "Tavush",
        vayots_dzor: "Vayots Dzor",
        yerevan: "Yerevan",
        description_museum: "Story",
        ourEvents: "OUR EVENTS",
        our_address: "Our address",
        working_hours: "Working hours",
        director: "Director",
        phone: "phones",
        educationalPrograms: "PERMANENT EXHIBITIONS OR EDUCATIONAL PROGRAMS",
        haveQuestions: "Do you have questions?",
        NumberOfVisitors: "Number of visitors",
        minCount: "minimum",
        maxCount: "The maximum",
        typeMessages: "Please select a message subject",
        educational_program: "Educational program",
        excursion: "Excursion",
        other: "Other",
        oneTicket: "Cost of one ticket",
        RegionsMussseum: "Regions",
        allMussseum: "All",
        // ==============Museum Page end===================

        abouteUsPage_title: [
          "ABOUT US",
          "History of the Ministry of Culture of Armenia",
        ],

        country: [
          { am: "Armenia" },
          { af: "Afghanistan" },
          { al: "Albania" },
          { dz: "Algeria" },
          { ad: "Andorra" },
          { ao: "Angola" },
          { ag: "Antigua and Barbuda" },
          { ar: "Argentina" },
          { au: "Australia" },
          { at: "Austria" },
          { bs: "Bahamas" },
          { bh: "Bahrain" },
          { bd: "Bangladesh" },
          { bb: "Barbados" },
          { by: "Belarus" },
          { be: "Belgium" },
          { bz: "Belize" },
          { bj: "Benin" },
          { bt: "Bhutan" },
          { bo: "Bolivia (Plurinational State of)" },
          { ba: "Bosnia and Herzegovina" },
          { bw: "Botswana" },
          { br: "Brazil" },
          { bn: "Brunei Darussalam" },
          { bg: "Bulgaria" },
          { bf: "Burkina Faso" },
          { bi: "Burundi" },
          { cv: "Cabo Verde" },
          { kh: "Cambodia" },
          { cm: "Cameroon" },
          { ca: "Canada" },
          { cf: "Central African Republic" },
          { td: "Chad" },
          { cl: "Chile" },
          { cn: "China" },
          { co: "Colombia" },
          { km: "Comoros" },
          { cg: "Congo" },
          { cd: "Congo, Democratic Republic of the" },
          { cr: "Costa Rica" },
          { ci: "Côte d'Ivoire" },
          { hr: "Croatia" },
          { cu: "Cuba" },
          { cy: "Cyprus" },
          { cz: "Czechia" },
          { dk: "Denmark" },
          { dj: "Djibouti" },
          { dm: "Dominica" },
          { do: "Dominican Republic" },
          { ec: "Ecuador" },
          { eg: "Egypt" },
          { sv: "El Salvador" },
          { gq: "Equatorial Guinea" },
          { er: "Eritrea" },
          { ee: "Estonia" },
          { sz: "Eswatini" },
          { et: "Ethiopia" },
          { fj: "Fiji" },
          { fi: "Finland" },
          { fr: "France" },
          { ga: "Gabon" },
          { gm: "Gambia" },
          { ge: "Georgia" },
          { de: "Germany" },
          { gh: "Ghana" },
          { gr: "Greece" },
          { gd: "Grenada" },
          { gt: "Guatemala" },
          { gn: "Guinea" },
          { gw: "Guinea-Bissau" },
          { gy: "Guyana" },
          { ht: "Haiti" },
          { hn: "Honduras" },
          { hu: "Hungary" },
          { is: "Iceland" },
          { in: "India" },
          { id: "Indonesia" },
          { ir: "Iran (Islamic Republic of)" },
          { iq: "Iraq" },
          { ie: "Ireland" },
          { il: "Israel" },
          { it: "Italy" },
          { jm: "Jamaica" },
          { jp: "Japan" },
          { jo: "Jordan" },
          { kz: "Kazakhstan" },
          { ke: "Kenya" },
          { ki: "Kiribati" },
          { kp: "Korea (Democratic People's Republic of)" },
          { kr: "Korea, Republic of" },
          { kw: "Kuwait" },
          { kg: "Kyrgyzstan" },
          { la: "Lao People's Democratic Republic" },
          { lv: "Latvia" },
          { lb: "Lebanon" },
          { ls: "Lesotho" },
          { lr: "Liberia" },
          { ly: "Libya" },
          { li: "Liechtenstein" },
          { lt: "Lithuania" },
          { lu: "Luxembourg" },
          { mg: "Madagascar" },
          { mw: "Malawi" },
          { my: "Malaysia" },
          { mv: "Maldives" },
          { ml: "Mali" },
          { mt: "Malta" },
          { mh: "Marshall Islands" },
          { mr: "Mauritania" },
          { mu: "Mauritius" },
          { mx: "Mexico" },
          { fm: "Micronesia (Federated States of)" },
          { md: "Moldova, Republic of" },
          { mc: "Monaco" },
          { mn: "Mongolia" },
          { me: "Montenegro" },
          { ma: "Morocco" },
          { mz: "Mozambique" },
          { mm: "Myanmar" },
          { na: "Namibia" },
          { nr: "Nauru" },
          { np: "Nepal" },
          { nl: "Netherlands" },
          { nz: "New Zealand" },
          { ni: "Nicaragua" },
          { ne: "Niger" },
          { ng: "Nigeria" },
          { mk: "North Macedonia" },
          { no: "Norway" },
          { om: "Oman" },
          { pk: "Pakistan" },
          { pw: "Palau" },
          { pa: "Panama" },
          { pg: "Papua New Guinea" },
          { py: "Paraguay" },
          { pe: "Peru" },
          { ph: "Philippines" },
          { pl: "Poland" },
          { pt: "Portugal" },
          { qa: "Qatar" },
          { ro: "Romania" },
          { ru: "Russian Federation" },
          { rw: "Rwanda" },
          { kn: "Saint Kitts and Nevis" },
          { lc: "Saint Lucia" },
          { vc: "Saint Vincent and the Grenadines" },
          { ws: "Samoa" },
          { sm: "San Marino" },
          { st: "Sao Tome and Principe" },
          { sa: "Saudi Arabia" },
          { sn: "Senegal" },
          { rs: "Serbia" },
          { sc: "Seychelles" },
          { sl: "Sierra Leone" },
          { sg: "Singapore" },
          { sk: "Slovakia" },
          { si: "Slovenia" },
          { sb: "Solomon Islands" },
          { so: "Somalia" },
          { za: "South Africa" },
          { ss: "South Sudan" },
          { es: "Spain" },
          { lk: "Sri Lanka" },
          { sd: "Sudan" },
          { sr: "Suriname" },
          { se: "Sweden" },
          { ch: "Switzerland" },
          { sy: "Syrian Arab Republic" },
          { tj: "Tajikistan" },
          { tz: "Tanzania, United Republic of" },
          { th: "Thailand" },
          { tl: "Timor-Leste" },
          { tg: "Togo" },
          { to: "Tonga" },
          { tt: "Trinidad and Tobago" },
          { tn: "Tunisia" },
          { tr: "Türkiye" },
          { tm: "Turkmenistan" },
          { tv: "Tuvalu" },
          { ug: "Uganda" },
          { ua: "Ukraine" },
          { ae: "United Arab Emirates" },
          { gb: "United Kingdom of Great Britain and Northern Ireland" },
          { us: "United States of America" },
          { uy: "Uruguay" },
          { uz: "Uzbekistan" },
          { vu: "Vanuatu" },
          { ve: "Venezuela (Bolivarian Republic of)" },
          { vn: "Viet Nam" },
          { ye: "Yemen" },
          { zm: "Zambia" },
          { zw: "Zimbabwe" },
        ],

        abouteUs_page_data: [
          'The history of the Ministry of Culture of Armenia begins with the times of the first Republic of Armenia. As part of the government of the first republic of Armenia in 1918. there was still no institution dealing with cultural matters. 1918 - 2019 the Ministry of Public Education was functioning. 1919 On May 21, Minister of Public Education Melik Gharagyozyan addressed the Council of Ministers, proposing to name the Ministry of Public Education the Ministry of Education and Fine Arts from now on. 1919 On July 1, the Ministry of Public Education and Arts was established with the departments of secondary schools, elementary schools, art and antiquities, and medical-sanitary departments. At the session of July 17, the RA Council of Ministers approves a law. "On reorganizing the department of ancient monuments and art. a) to reorganize the department of ancient monuments and art into two departments: a. preservation of ancient monuments, b. art patronage.',
          'b) key of the Ministry of Public Education and Arts in 1919. additional credit of twenty two thousand two hundred rubles for the months of July-December. Manager of affairs of the Council of Ministers: G. Khojamiryan". By this law, the Department of Antiquities Protection is added to the structure of the Ministry of Public Education and Arts. The ministry s constant focus was the preservation of antiquities, as evidenced by a number of documents. The Antiquities Department functioned until 1920 and was dissolved due to the transfer of functions to the Antiquities Committee. The issue of the Future National Museum, as well as theater activities, were also in the center of attention of the Ministry. In 1920 From January 1 to June 1, Yeghishe Soghomyan (Charents) held the position of Commissioner for Special Assignments of the Ministry of Education and Arts.',
          "The Museum of the History of Armenia is a cultural organization of national importance, which for more than a century has acquired, collected, discovered, recorded, preserved, studied, interpreted and exhibited tangible and intangible cultural values related to Armenia and Armenian people, contributing to science, education, tourism. development. Based on nearly four hundred thousand archaeological, ethnographic, numismatic and other collections, the museum tries to bridge the past and the future. The museums collection reflects the full picture of culture and history of Armenia from prehistoric times (one million eight hundred thousand years ago) to the present day. The museum was established by Law 439 of the Parliament of the First Republic of Armenia (09.09.1919). It was called the Ethnographic-Anthropological Museum-Library. It was opened for visitors in 1921. on August 20. Undergo a name change. State Central of Armenia (1922), Cultural-Historical (1931), Historical (1935), State History Museum of Armenia (1962) and History Museum of Armenia (2003).",
        ],

        sale_ticket_page_Text_part_1: [
          "1) Children under 12 years old,",
          "2) To the members of the official state delegations that arrived in Armenia,",
          "3) Diplomatic representatives accredited in Armenia,",
          "4) To the members of the International Council of Museums (ICOM), museum workers,",
          "5) bilaterally orphaned children over 12 years of age, elderly people in need of special care and domestic service,",
          "6) To the members of the families of servicemen who died while performing their official duties during combat operations in the territories of the Republic of Armenia and the Republic of Artsakh,",
          "7) Participants of the Second World War (of the Republic of Armenia and former USSR states),",
          "8) persons with disabilities of the 1st group (with a companion), persons with disabilities of the 2nd and 3rd groups (without a companion), beneficiaries included in the poverty (family) benefit system,",
          "9) children over the age of 12 from large families,",
          "10) conscripts,",
          "11) Children of school age over 12 years old in the border regions of the Republic of Armenia (on the basis of applications submitted in advance),",
          "12) journalists - on all working days (in the presence of a document confirming the identity and status),",
          "13) Entry is free for citizens of the Republic of Armenia on the last Saturday of every month.",
        ],

        sale_ticket_page_Text_part_2: [
          "1) Ticket price with a 50% discount for schoolchildren over 12 years old, students, pensioners who are citizens of the Republic of Armenia, refugees.",
          "2) Allow to reduce the prices of tickets for permanent visits in case of sale of a large number of tickets for tourist and corporate purposes to:",
          "3) In the amount of 10 percent, having previously concluded appropriate agreements with tour operators or agents:",
        ],

        sale_ticket_page_block_titles: [
          "FREE ACCESS TO THE PERMANENT EXHIBITION OF THE MUSEUM IS PROVIDED",
          "Discounts",
        ],

        sale_ticket_page_title: "Ticket Discount Policy",

        sale_ticket_page_botom_block: {
          title:
            "ON THE ESTABLISHMENT OF BENEFITS FOR LOCAL FEES IN THE COMMUNITY OF YEREVAN IN 2025",
          part_1: {
            title: "Kindergarten Fees (2025)",
            subTitle: "Local fee of 0 AMD is paid by:",
            list: [
              {
                title:
                  "The parent or legal guardian of the child is permanently/actually registered in the city of Yerevan.",
              },
              {
                title: "The child:",
                items: [
                  "from a family of a deceased serviceman",
                  "Parent is a serviceman or participated in combat operations",
                  "Parent died/missing in the line of duty",
                  "is a full or partial orphan",
                  "has a parent with a disability of group 1 or 2",
                  "has a disability or requires special conditions",
                  "Internally displaced person",
                  "Has refugee or asylum seeker status",
                  "From a family forcibly displaced from Artsakh",
                ],
              },
            ],
            botomText: "12,000 AMD monthly fee — for all other children.",
          },
          part_2: {
            title:
              "Extracurricular Institutions (Music, Art, Fine Arts Schools)",
            list: [
              {
                title: "0 AMD:",
                items: [
                  "Children of deceased servicemen",
                  "Participants of the Yerevan Youth Symphony Orchestra",
                ],
              },
              {
                title: "8,000 AMD per month:",
                items: [
                  "Advanced singing",
                  "Instrumental departments (piano, strings, wind, national instruments, percussion, accordion, tavizh, guitar, dhol)",
                  "Singing",
                  "Choreography",
                  "Visual arts",
                  "Theatre arts",
                ],
              },
              {
                title: "4,000 AMD:",
                items: [
                  "Families with 4 or more children",
                  "Families with a parent with a disability",
                  "If the student attends a second program (singing/instrumental department)",
                ],
              },
              {
                title:
                  "Up to 100 children who had payment issues due to pre-2018 payment differences:",
                items: ["0 AMD", "4,000 AMD by mayor's decision"],
              },
            ],
          },
        },

        /////////////////////news////////////////
        newses_page_data: ["NEWS", "Search"],
        ///////////////////shop/////////////////////////
        shop_page_data: [
          "SHOP",
          "By categories",
          "By museums",
          "No data found",
        ],
        single_shop_page: [
          "AMD",
          "CATEGORY",
          "SIMILAR PRODUCTS",
          "No data found",
        ],

        privacyPolisyTitle: "Privacy Policy",

        privacyPolisy_left_div: [
          "Security of personal data:",
          "Introduction This Privacy Policy governs our use of your personal information.",
          "Privacy of information:",
          "The information you provide to us is considered strictly confidential and may not be provided to any third party",
          "Collection of information:",
          "We may collect and store the personal information described below.",
          "E-mail address, full name, phone number.",
          "We DO NOT have any data of your payment (credit or debit) card, as online purchases / donations / and other transactions on our site are carried out exclusively with international Visa and MasterCard cards and go through Verified by Visa and MasterCard Secure Code prefixes.",
          "The history of your purchases / donations / and other transactions on the site and the list of preferred products / programs.",
          "Correspondence (emails), if any, with us.",
        ],

        privacyPolisy_right_div: [
          "Use of Information:",
          "The primary purpose of collecting personal information for us is to provide you with safe, convenient, efficient and personalized services. You hereby consent that we may use your personal information solely for the following purposes:",
          "Providing the service and assistance you requested.",
          "Evaluating and improving our services, content and quality.",
          "In unusual situations, a phone call or email. verifying or reporting additional information by mail.",
          "In unusual situations, a phone call or email. verifying or reporting additional information by mail.",
        ],

        faqTitle: "Frequently asked Questions",

        faqUserRequestsData: [
          "Which museum can I buy tickets for?",
          "Visitors to our site can purchase tickets for all museums listed on the site.",
          "What is the validity period of the purchased ticket?",
          "The ticket purchased from the system is valid for 365 days.",
          "What is a Single Ticket?",
          "A single ticket is a package of tickets for several museums, which you will get a discount on.",
          "When buying a ticket, how do I get my ticket?",
          "If you buy a ticket from the website, you will receive the ticket and a QR code to your e-mail address, with which you can visit the museum.",
          "What does Subscription mean?",
          "A season ticket is an unlimited entry ticket to one museum that is valid for 365 days.",
        ],

        faq_free_tickets_title: "Free tickets",

        faq_sale_tickets_title: "Discounted tickets",

        faq_free_tickets: [
          "Children up to 12 years old",
          "To the members of the official state delegations that arrived in Armenia,",
          "diplomatic representatives accredited in Armenia,",
          "To the members of the International Council of Museums (ICOM), museum workers,",
          "bilaterally orphaned children over 12 years of age, elderly people in need of special care and domestic service,",
          "To the members of the families of servicemen who died while performing their official duties during combat operations in the territories of the Republic of Armenia and the Republic of Artsakh,",
          "Participants of the Second World War (of the Republic of Armenia and former USSR states),",
          "persons with disabilities of the 1st group (with a companion), persons with disabilities of the 2nd and 3rd groups (without a companion), beneficiaries included in the poverty (family) benefit system",
          "children over the age of 12 from large families,",
          "conscripts",
          "Children of school age over 12 years old in the border regions of the Republic of Armenia (on the basis of applications submitted in advance),",
          "journalists - on all working days (in the presence of a document confirming the identity and status),",
          "Entry is free for citizens of the Republic of Armenia on the last Saturday of every month.",
        ],

        faq_sale_tickets: [
          "The ticket price of the Museum of All RA Normative Acts is discounted by 50% in the following cases:",
          "Schoolchildren over 12 years old",
          "students,",
          "Pensioners who are citizens of the Republic of Armenia,",
          "Refugees",
        ],

        privateTicketRegions: [
          { bolor: "All" },
          { yerevan: "Yerevan" },
          { aragatsotn: "Aragatsotn" },
          { ararat: "Ararat" },
          { armavir: "Armavir" },
          { gegharkunik: "Gegharkunik" },
          { kotayk: "Kotayk" },
          { lori: "Lori" },
          { shirak: "Shirak" },
          { syunik: "Syunik" },
          { tavush: "Tavush" },
          { vayots_dzor: "Vayots Dzor" },
        ],

        chatBotHint: [
          "Please indicate in message",
          "Desired day",
          "Number of participants",
          "What age group are we talking about?",
          "Name of organization or individual",
          "Phone number",
          "Specify the language of the manual",
        ],
        otherMessagesBot: "Write your message",
        warningMessages: "Do you want to continue?",
        startMessages: [
          "If you are not registered, please write us your email address. letter to receive a response letter from the museum",
          "Hello. Nice to see you here. By clicking the Start Chat button, you agree to the processing of your personal data as described in our Privacy Policy.",
        ],
        musseumPage_title: ["MUSEUMS OF ARMENIA", "Filter", "Read more"],
        webSideMusum: [
          "WEB SITE",
          "invate",
          "Museum membership card",
          "Link copied to clipboard",
        ],
        ButtonBlock: [
          "By purchasing a subscription, you can visit the museum an unlimited number of times for 365 days:",
          "Write for tour guide, educational programs and other questions",
        ],
        ticketsType: [
          "Permanent display",
          "Membership card",
          "United ticket",
          "Temporary exhibitions",
        ],

        ticketsType_for_private: [
          { standart: "Standart ticket" },
          { discount: "Discounted Ticket" },
          { free: "Free ticket" },
          { subscription: "Membership card" },
          { united: "United ticket" },
          { event: "Event" },
          { product: "Product" },
          { special: "Special ticket" },
        ],

        specialTicketLabel: "Special Ticket",
        specialTicketDiscountLabel: "Discount",
        specialTicketScheduleLabel: "Special Ticket day/time",

        weekDaysList: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],

        Ticket_type_placeholder: [
          "Region",
          "Choose region",
          "Museum",
          "Choose museum",
          "Event",
          "Choose Event",
          "Buy ticket",
          "Summary - ",
          "Sign in to add a ticket or item to cart.",
        ],
        standart: "Standart",
        discount: "Discount",
        free: "Free",

        infoBuyTicket: [
          "Come to the museum for a free ticket",
          "Tour guide in Armenian language",
          "Tour guide in a foreign language",
          "To use the service of a tour guide, you need to make a reservation in advance.",
          "Total",
          "Buy Ticket",
          "Membership card",
          "Membership card is unlimited access for 365 days.",
          "Come by the museum for a discounted ticket",
          "For discounted and free tickets, come to the museum.",
        ],
        selectCategory: "Select  category",
        book: "Book",
        souvenir: "Souvenir",
        clothes: "Clothes",

        ticket_error_message: "Ticket not selected",

        eventPageTitle: "Events of museums of Armenia",

        location_name:
          "Government House 2, Vazgen Sargsyan 3, Yerevan 0010, Armenia",

        app_stor_and_google_play: "Download our App",

        footer_botom:
          "  Museums of Armenia. Copyright reserved. Site created by",

        event_single_page: ["See more", "Buy ticket", "Description", "Invite"],

        event_single_page_modal: [
          "Date",
          "Time",
          "Price",
          "Number of tickets available",
          "Discount Price",
        ],

        more_events: "Similar events",

        mintitle: "Museums of Armenia on one platform",
        educationTitle: [
          "Contact the museum to order tickets for educational programs by ",
          "message",
          "or call.",
        ],

        thisMuseum: "Shop of this museum",
        buy: "Buy",
        productsErrorMessages: "No products found",
        Showing: ["Showing ", "of", "results"],
        virtualExcursion: "Virtual Excursion",
        museumBranch: "Branches of the museum",

        isWrong: [
          "Something is wrong!",
          "There are currently no tickets available",
          "Products added to cart",
          "Fill in the fields to buy a ticket",
          "Purchased e-tickets will be sent to the e-mail you specified",
        ],

        section_united_ticket: [
          "BUY A UNITED TICKET FOR",
          "OR MORE MUSEUMS AND GET",
          "PERCENT DISCOUNT",
        ],

        my_account_page: [
          "My Account",
          "Gender",
          "Male",
          "Female",
          "Other",
          "Save",
          "Log out",
        ],

        order_history: [
          "Order Id",
          "Name of museum",
          "Product / Ticket",
          "Count",
          "Purchase date",
          "Price",
          "Status",
          "Failed",
          "Confirmed",
          "Order History",
        ],

        profil_side_bar: [
          "My account",
          "Messages",
          "Orders",
          "QR code",
          "Notifications",
          "Donations",
        ],

        notificationMessages: [
          "Your changes have been successfully saved.",
          "Your changes cannot be saved at this time.Please try again later.",
          "You can download your tickets here",
          "Your payment was successful. Check your email or personal page.",
        ],

        start_date: "Start date",
        end_date: "End date",

        qr_standard_price: "Standard price",
        qr_final_price: "Final price",
        qr_valid_days_hours: "Valid days and hours",

        qr_modal: ["Download", "Print", "Send email"],

        event_config: "Event",

        shop_page_title: ["SHOP", "Products of museums in Armenia"],

        shop_search: "Search",

        shop_product_category: [
          { book: "Book" },
          { souvenir: "Souvenir" },
          { clothes: "Clothes" },
          { other: "other" },
        ],

        shop_all_category: "All Categories",

        shop_all_Museums: "All Museums",

        news_titles: ["News", "News of MESCS", "Search"],

        contactUsPage: [
          "CONTACT WITH US",
          "Ministry of Education, Science, Culture and Sports",
          "ADDRESS",
          "Government House 2, Vazgen Sargsyan 3, Yerevan 0010, Armenia",
          "Phone number",
          "E-mail",
        ],

        united_ticketPage_title:
          "The single ticket is valid for 365 days and is non-refundable.",

        united_ticketPage_selectedItems: [
          "You have selected a combined ticket for",
          "museums",
        ],

        single_shop: ["is available - ", "Price "],

        chat_empty_message: "You have no messages yet.",

        yourCartTitle: "Cart",

        yourCartMessage:"The cart displays currently available tickets with their exact prices.",

        invalidPage: ["Back to Home Page", "Page not found"],

        storeErrorPage: "Page is temporarily unavailable",

        eventTypes: ["Event", "Temporary exhibition"],

        cardCheckout: "Pay",

        cardDelte: "Delete all",

        otherServices: "Other services",

        otherServicesSubTitle: "You can see other museum services here.",

        donationBlock: {
          title: "Support Our Culture",
          description:
            "With your help, we can continue organizing new exhibitions, restoring valuable artifacts, and educating new generations.",
          textareaPlaceholder: "Purpose...",
          selectPrice: "Select donation amount",
          otherBtn: "Other",
          sendBtn: "Donate",
          processingBtn: "Выполняется...",
          priceType: "AMD",
          otherInputPlaceholder: "Amount",
          minDonationPrice: 1,

          // ✅ Validation messages
          validations: {
            messageMax: "The message cannot be longer than 500 characters",
            choosePrice: "Please select an amount",
            invalidChoice: "Invalid choice",
            otherRequired: "Please enter your desired amount",
            otherTypeError: "Enter a numeric value",
            otherMin: `The amount must be at least {{min}} AMD`,
          },
        },

        donationsList: {
          title: "Your Donations",
          status: {
            pending: "Pending",
            confirmed: "Confirmed",
            deny: "Denied",
          },
          tableHead: {
            id: "Donation ID",
            museum_name: "Museum Name",
            amount: "Donation Amount",
            status: "Status",
            date: "Date",
          },
        },

        donationSectionHome: {
          title: "Donate Now",
          description:
            "Every dram you give helps preserve Armenia’s cultural heritage and create new exhibitions",
        },
      },
    },
  },
  lng: localStorage.getItem("lang") ? localStorage.getItem("lang") : "am",
  fallbackLng: localStorage.getItem("lang"),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
